var Wi = Object.defineProperty, qi = Object.defineProperties;
var zi = Object.getOwnPropertyDescriptors;
var mr = Object.getOwnPropertySymbols;
var Gi = Object.prototype.hasOwnProperty, Ji = Object.prototype.propertyIsEnumerable;
var gr = (e, t, n) => t in e ? Wi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ye = (e, t) => {
  for (var n in t || (t = {}))
    Gi.call(t, n) && gr(e, n, t[n]);
  if (mr)
    for (var n of mr(t))
      Ji.call(t, n) && gr(e, n, t[n]);
  return e;
}, kt = (e, t) => qi(e, zi(t));
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Ws(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const ue = {}, zt = [], lt = () => {
}, Qi = () => !1, Gn = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), qs = (e) => e.startsWith("onUpdate:"), ve = Object.assign, zs = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Yi = Object.prototype.hasOwnProperty, re = (e, t) => Yi.call(e, t), j = Array.isArray, Gt = (e) => Jn(e) === "[object Map]", go = (e) => Jn(e) === "[object Set]", G = (e) => typeof e == "function", _e = (e) => typeof e == "string", mt = (e) => typeof e == "symbol", he = (e) => e !== null && typeof e == "object", _o = (e) => (he(e) || G(e)) && G(e.then) && G(e.catch), vo = Object.prototype.toString, Jn = (e) => vo.call(e), Xi = (e) => Jn(e).slice(8, -1), Qn = (e) => Jn(e) === "[object Object]", Gs = (e) => _e(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, cn = /* @__PURE__ */ Ws(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Yn = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, Zi = /-(\w)/g, Ge = Yn(
  (e) => e.replace(Zi, (t, n) => n ? n.toUpperCase() : "")
), el = /\B([A-Z])/g, Ue = Yn(
  (e) => e.replace(el, "-$1").toLowerCase()
), yo = Yn((e) => e.charAt(0).toUpperCase() + e.slice(1)), as = Yn(
  (e) => e ? `on${yo(e)}` : ""
), xt = (e, t) => !Object.is(e, t), Ln = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, bo = (e, t, n, s = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: s,
    value: n
  });
}, Ss = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Cs = (e) => {
  const t = _e(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let _r;
const Xn = () => _r || (_r = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function Js(e) {
  if (j(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n], r = _e(s) ? rl(s) : Js(s);
      if (r)
        for (const o in r)
          t[o] = r[o];
    }
    return t;
  } else if (_e(e) || he(e))
    return e;
}
const tl = /;(?![^(]*\))/g, nl = /:([^]+)/, sl = /\/\*[^]*?\*\//g;
function rl(e) {
  const t = {};
  return e.replace(sl, "").split(tl).forEach((n) => {
    if (n) {
      const s = n.split(nl);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function Zn(e) {
  let t = "";
  if (_e(e))
    t = e;
  else if (j(e))
    for (let n = 0; n < e.length; n++) {
      const s = Zn(e[n]);
      s && (t += s + " ");
    }
  else if (he(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const ol = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", il = /* @__PURE__ */ Ws(ol);
function wo(e) {
  return !!e || e === "";
}
const xo = (e) => !!(e && e.__v_isRef === !0), pe = (e) => _e(e) ? e : e == null ? "" : j(e) || he(e) && (e.toString === vo || !G(e.toString)) ? xo(e) ? pe(e.value) : JSON.stringify(e, So, 2) : String(e), So = (e, t) => xo(t) ? So(e, t.value) : Gt(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [s, r], o) => (n[us(s, o) + " =>"] = r, n),
    {}
  )
} : go(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => us(n))
} : mt(t) ? us(t) : he(t) && !j(t) && !Qn(t) ? String(t) : t, us = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    mt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Re;
class ll {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Re, !t && Re && (this.index = (Re.scopes || (Re.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = Re;
      try {
        return Re = this, t();
      } finally {
        Re = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Re = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Re = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, s;
      for (n = 0, s = this.effects.length; n < s; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        for (n = 0, s = this.scopes.length; n < s; n++)
          this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Co() {
  return Re;
}
function cl(e, t = !1) {
  Re && Re.cleanups.push(e);
}
let de;
const fs = /* @__PURE__ */ new WeakSet();
class Eo {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Re && Re.active && Re.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, fs.has(this) && (fs.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Mo(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, vr(this), Ao(this);
    const t = de, n = Je;
    de = this, Je = !0;
    try {
      return this.fn();
    } finally {
      ko(this), de = t, Je = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Xs(t);
      this.deps = this.depsTail = void 0, vr(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? fs.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Es(this) && this.run();
  }
  get dirty() {
    return Es(this);
  }
}
let To = 0, an, un;
function Mo(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = un, un = e;
    return;
  }
  e.next = an, an = e;
}
function Qs() {
  To++;
}
function Ys() {
  if (--To > 0)
    return;
  if (un) {
    let t = un;
    for (un = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; an; ) {
    let t = an;
    for (an = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function Ao(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function ko(e) {
  let t, n = e.depsTail, s = n;
  for (; s; ) {
    const r = s.prevDep;
    s.version === -1 ? (s === n && (n = r), Xs(s), al(s)) : t = s, s.dep.activeLink = s.prevActiveLink, s.prevActiveLink = void 0, s = r;
  }
  e.deps = t, e.depsTail = n;
}
function Es(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Io(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Io(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === pn))
    return;
  e.globalVersion = pn;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !Es(e)) {
    e.flags &= -3;
    return;
  }
  const n = de, s = Je;
  de = e, Je = !0;
  try {
    Ao(e);
    const r = e.fn(e._value);
    (t.version === 0 || xt(r, e._value)) && (e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    de = n, Je = s, ko(e), e.flags &= -3;
  }
}
function Xs(e, t = !1) {
  const { dep: n, prevSub: s, nextSub: r } = e;
  if (s && (s.nextSub = r, e.prevSub = void 0), r && (r.prevSub = s, e.nextSub = void 0), n.subs === e && (n.subs = s, !s && n.computed)) {
    n.computed.flags &= -5;
    for (let o = n.computed.deps; o; o = o.nextDep)
      Xs(o, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function al(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let Je = !0;
const Oo = [];
function Et() {
  Oo.push(Je), Je = !1;
}
function Tt() {
  const e = Oo.pop();
  Je = e === void 0 ? !0 : e;
}
function vr(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = de;
    de = void 0;
    try {
      t();
    } finally {
      de = n;
    }
  }
}
let pn = 0;
class ul {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Zs {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0;
  }
  track(t) {
    if (!de || !Je || de === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== de)
      n = this.activeLink = new ul(de, this), de.deps ? (n.prevDep = de.depsTail, de.depsTail.nextDep = n, de.depsTail = n) : de.deps = de.depsTail = n, Lo(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const s = n.nextDep;
      s.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = s), n.prevDep = de.depsTail, n.nextDep = void 0, de.depsTail.nextDep = n, de.depsTail = n, de.deps === n && (de.deps = s);
    }
    return n;
  }
  trigger(t) {
    this.version++, pn++, this.notify(t);
  }
  notify(t) {
    Qs();
    try {
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      Ys();
    }
  }
}
function Lo(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let s = t.deps; s; s = s.nextDep)
        Lo(s);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
  }
}
const jn = /* @__PURE__ */ new WeakMap(), Dt = Symbol(
  ""
), Ts = Symbol(
  ""
), mn = Symbol(
  ""
);
function Me(e, t, n) {
  if (Je && de) {
    let s = jn.get(e);
    s || jn.set(e, s = /* @__PURE__ */ new Map());
    let r = s.get(n);
    r || (s.set(n, r = new Zs()), r.map = s, r.key = n), r.track();
  }
}
function dt(e, t, n, s, r, o) {
  const i = jn.get(e);
  if (!i) {
    pn++;
    return;
  }
  const l = (c) => {
    c && c.trigger();
  };
  if (Qs(), t === "clear")
    i.forEach(l);
  else {
    const c = j(e), u = c && Gs(n);
    if (c && n === "length") {
      const a = Number(s);
      i.forEach((d, p) => {
        (p === "length" || p === mn || !mt(p) && p >= a) && l(d);
      });
    } else
      switch ((n !== void 0 || i.has(void 0)) && l(i.get(n)), u && l(i.get(mn)), t) {
        case "add":
          c ? u && l(i.get("length")) : (l(i.get(Dt)), Gt(e) && l(i.get(Ts)));
          break;
        case "delete":
          c || (l(i.get(Dt)), Gt(e) && l(i.get(Ts)));
          break;
        case "set":
          Gt(e) && l(i.get(Dt));
          break;
      }
  }
  Ys();
}
function fl(e, t) {
  const n = jn.get(e);
  return n && n.get(t);
}
function Bt(e) {
  const t = se(e);
  return t === e ? t : (Me(t, "iterate", mn), qe(e) ? t : t.map(Ae));
}
function es(e) {
  return Me(e = se(e), "iterate", mn), e;
}
const dl = {
  __proto__: null,
  [Symbol.iterator]() {
    return ds(this, Symbol.iterator, Ae);
  },
  concat(...e) {
    return Bt(this).concat(
      ...e.map((t) => j(t) ? Bt(t) : t)
    );
  },
  entries() {
    return ds(this, "entries", (e) => (e[1] = Ae(e[1]), e));
  },
  every(e, t) {
    return at(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return at(this, "filter", e, t, (n) => n.map(Ae), arguments);
  },
  find(e, t) {
    return at(this, "find", e, t, Ae, arguments);
  },
  findIndex(e, t) {
    return at(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return at(this, "findLast", e, t, Ae, arguments);
  },
  findLastIndex(e, t) {
    return at(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return at(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return hs(this, "includes", e);
  },
  indexOf(...e) {
    return hs(this, "indexOf", e);
  },
  join(e) {
    return Bt(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return hs(this, "lastIndexOf", e);
  },
  map(e, t) {
    return at(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return sn(this, "pop");
  },
  push(...e) {
    return sn(this, "push", e);
  },
  reduce(e, ...t) {
    return yr(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return yr(this, "reduceRight", e, t);
  },
  shift() {
    return sn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return at(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return sn(this, "splice", e);
  },
  toReversed() {
    return Bt(this).toReversed();
  },
  toSorted(e) {
    return Bt(this).toSorted(e);
  },
  toSpliced(...e) {
    return Bt(this).toSpliced(...e);
  },
  unshift(...e) {
    return sn(this, "unshift", e);
  },
  values() {
    return ds(this, "values", Ae);
  }
};
function ds(e, t, n) {
  const s = es(e), r = s[t]();
  return s !== e && !qe(e) && (r._next = r.next, r.next = () => {
    const o = r._next();
    return o.value && (o.value = n(o.value)), o;
  }), r;
}
const hl = Array.prototype;
function at(e, t, n, s, r, o) {
  const i = es(e), l = i !== e && !qe(e), c = i[t];
  if (c !== hl[t]) {
    const d = c.apply(e, o);
    return l ? Ae(d) : d;
  }
  let u = n;
  i !== e && (l ? u = function(d, p) {
    return n.call(this, Ae(d), p, e);
  } : n.length > 2 && (u = function(d, p) {
    return n.call(this, d, p, e);
  }));
  const a = c.call(i, u, s);
  return l && r ? r(a) : a;
}
function yr(e, t, n, s) {
  const r = es(e);
  let o = n;
  return r !== e && (qe(e) ? n.length > 3 && (o = function(i, l, c) {
    return n.call(this, i, l, c, e);
  }) : o = function(i, l, c) {
    return n.call(this, i, Ae(l), c, e);
  }), r[t](o, ...s);
}
function hs(e, t, n) {
  const s = se(e);
  Me(s, "iterate", mn);
  const r = s[t](...n);
  return (r === -1 || r === !1) && nr(n[0]) ? (n[0] = se(n[0]), s[t](...n)) : r;
}
function sn(e, t, n = []) {
  Et(), Qs();
  const s = se(e)[t].apply(e, n);
  return Ys(), Tt(), s;
}
const pl = /* @__PURE__ */ Ws("__proto__,__v_isRef,__isVue"), Ro = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(mt)
);
function ml(e) {
  mt(e) || (e = String(e));
  const t = se(this);
  return Me(t, "has", e), t.hasOwnProperty(e);
}
class $o {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, s) {
    if (n === "__v_skip") return t.__v_skip;
    const r = this._isReadonly, o = this._isShallow;
    if (n === "__v_isReactive")
      return !r;
    if (n === "__v_isReadonly")
      return r;
    if (n === "__v_isShallow")
      return o;
    if (n === "__v_raw")
      return s === (r ? o ? El : Do : o ? Po : Fo).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(s) ? t : void 0;
    const i = j(t);
    if (!r) {
      let c;
      if (i && (c = dl[n]))
        return c;
      if (n === "hasOwnProperty")
        return ml;
    }
    const l = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Ce(t) ? t : s
    );
    return (mt(n) ? Ro.has(n) : pl(n)) || (r || Me(t, "get", n), o) ? l : Ce(l) ? i && Gs(n) ? l : l.value : he(l) ? r ? jo(l) : Zt(l) : l;
  }
}
class No extends $o {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, s, r) {
    let o = t[n];
    if (!this._isShallow) {
      const c = Ht(o);
      if (!qe(s) && !Ht(s) && (o = se(o), s = se(s)), !j(t) && Ce(o) && !Ce(s))
        return c ? !1 : (o.value = s, !0);
    }
    const i = j(t) && Gs(n) ? Number(n) < t.length : re(t, n), l = Reflect.set(
      t,
      n,
      s,
      Ce(t) ? t : r
    );
    return t === se(r) && (i ? xt(s, o) && dt(t, "set", n, s) : dt(t, "add", n, s)), l;
  }
  deleteProperty(t, n) {
    const s = re(t, n);
    t[n];
    const r = Reflect.deleteProperty(t, n);
    return r && s && dt(t, "delete", n, void 0), r;
  }
  has(t, n) {
    const s = Reflect.has(t, n);
    return (!mt(n) || !Ro.has(n)) && Me(t, "has", n), s;
  }
  ownKeys(t) {
    return Me(
      t,
      "iterate",
      j(t) ? "length" : Dt
    ), Reflect.ownKeys(t);
  }
}
class gl extends $o {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const _l = /* @__PURE__ */ new No(), vl = /* @__PURE__ */ new gl(), yl = /* @__PURE__ */ new No(!0);
const Ms = (e) => e, En = (e) => Reflect.getPrototypeOf(e);
function bl(e, t, n) {
  return function(...s) {
    const r = this.__v_raw, o = se(r), i = Gt(o), l = e === "entries" || e === Symbol.iterator && i, c = e === "keys" && i, u = r[e](...s), a = n ? Ms : t ? As : Ae;
    return !t && Me(
      o,
      "iterate",
      c ? Ts : Dt
    ), {
      // iterator protocol
      next() {
        const { value: d, done: p } = u.next();
        return p ? { value: d, done: p } : {
          value: l ? [a(d[0]), a(d[1])] : a(d),
          done: p
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Tn(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function wl(e, t) {
  const n = {
    get(r) {
      const o = this.__v_raw, i = se(o), l = se(r);
      e || (xt(r, l) && Me(i, "get", r), Me(i, "get", l));
      const { has: c } = En(i), u = t ? Ms : e ? As : Ae;
      if (c.call(i, r))
        return u(o.get(r));
      if (c.call(i, l))
        return u(o.get(l));
      o !== i && o.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && Me(se(r), "iterate", Dt), Reflect.get(r, "size", r);
    },
    has(r) {
      const o = this.__v_raw, i = se(o), l = se(r);
      return e || (xt(r, l) && Me(i, "has", r), Me(i, "has", l)), r === l ? o.has(r) : o.has(r) || o.has(l);
    },
    forEach(r, o) {
      const i = this, l = i.__v_raw, c = se(l), u = t ? Ms : e ? As : Ae;
      return !e && Me(c, "iterate", Dt), l.forEach((a, d) => r.call(o, u(a), u(d), i));
    }
  };
  return ve(
    n,
    e ? {
      add: Tn("add"),
      set: Tn("set"),
      delete: Tn("delete"),
      clear: Tn("clear")
    } : {
      add(r) {
        !t && !qe(r) && !Ht(r) && (r = se(r));
        const o = se(this);
        return En(o).has.call(o, r) || (o.add(r), dt(o, "add", r, r)), this;
      },
      set(r, o) {
        !t && !qe(o) && !Ht(o) && (o = se(o));
        const i = se(this), { has: l, get: c } = En(i);
        let u = l.call(i, r);
        u || (r = se(r), u = l.call(i, r));
        const a = c.call(i, r);
        return i.set(r, o), u ? xt(o, a) && dt(i, "set", r, o) : dt(i, "add", r, o), this;
      },
      delete(r) {
        const o = se(this), { has: i, get: l } = En(o);
        let c = i.call(o, r);
        c || (r = se(r), c = i.call(o, r)), l && l.call(o, r);
        const u = o.delete(r);
        return c && dt(o, "delete", r, void 0), u;
      },
      clear() {
        const r = se(this), o = r.size !== 0, i = r.clear();
        return o && dt(
          r,
          "clear",
          void 0,
          void 0
        ), i;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    n[r] = bl(r, e, t);
  }), n;
}
function er(e, t) {
  const n = wl(e, t);
  return (s, r, o) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? s : Reflect.get(
    re(n, r) && r in s ? n : s,
    r,
    o
  );
}
const xl = {
  get: /* @__PURE__ */ er(!1, !1)
}, Sl = {
  get: /* @__PURE__ */ er(!1, !0)
}, Cl = {
  get: /* @__PURE__ */ er(!0, !1)
};
const Fo = /* @__PURE__ */ new WeakMap(), Po = /* @__PURE__ */ new WeakMap(), Do = /* @__PURE__ */ new WeakMap(), El = /* @__PURE__ */ new WeakMap();
function Tl(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Ml(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Tl(Xi(e));
}
function Zt(e) {
  return Ht(e) ? e : tr(
    e,
    !1,
    _l,
    xl,
    Fo
  );
}
function Al(e) {
  return tr(
    e,
    !1,
    yl,
    Sl,
    Po
  );
}
function jo(e) {
  return tr(
    e,
    !0,
    vl,
    Cl,
    Do
  );
}
function tr(e, t, n, s, r) {
  if (!he(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const o = r.get(e);
  if (o)
    return o;
  const i = Ml(e);
  if (i === 0)
    return e;
  const l = new Proxy(
    e,
    i === 2 ? s : n
  );
  return r.set(e, l), l;
}
function Jt(e) {
  return Ht(e) ? Jt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Ht(e) {
  return !!(e && e.__v_isReadonly);
}
function qe(e) {
  return !!(e && e.__v_isShallow);
}
function nr(e) {
  return e ? !!e.__v_raw : !1;
}
function se(e) {
  const t = e && e.__v_raw;
  return t ? se(t) : e;
}
function kl(e) {
  return !re(e, "__v_skip") && Object.isExtensible(e) && bo(e, "__v_skip", !0), e;
}
const Ae = (e) => he(e) ? Zt(e) : e, As = (e) => he(e) ? jo(e) : e;
function Ce(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function ge(e) {
  return Il(e, !1);
}
function Il(e, t) {
  return Ce(e) ? e : new Ol(e, t);
}
class Ol {
  constructor(t, n) {
    this.dep = new Zs(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : se(t), this._value = n ? t : Ae(t), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, s = this.__v_isShallow || qe(t) || Ht(t);
    t = s ? t : se(t), xt(t, n) && (this._rawValue = t, this._value = s ? t : Ae(t), this.dep.trigger());
  }
}
function me(e) {
  return Ce(e) ? e.value : e;
}
const Ll = {
  get: (e, t, n) => t === "__v_raw" ? e : me(Reflect.get(e, t, n)),
  set: (e, t, n, s) => {
    const r = e[t];
    return Ce(r) && !Ce(n) ? (r.value = n, !0) : Reflect.set(e, t, n, s);
  }
};
function Ho(e) {
  return Jt(e) ? e : new Proxy(e, Ll);
}
function Rl(e) {
  const t = j(e) ? new Array(e.length) : {};
  for (const n in e)
    t[n] = Nl(e, n);
  return t;
}
class $l {
  constructor(t, n, s) {
    this._object = t, this._key = n, this._defaultValue = s, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const t = this._object[this._key];
    return this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return fl(se(this._object), this._key);
  }
}
function Nl(e, t, n) {
  const s = e[t];
  return Ce(s) ? s : new $l(e, t, n);
}
class Fl {
  constructor(t, n, s) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new Zs(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = pn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = s;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    de !== this)
      return Mo(this, !0), !0;
  }
  get value() {
    const t = this.dep.track();
    return Io(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
function Pl(e, t, n = !1) {
  let s, r;
  return G(e) ? s = e : (s = e.get, r = e.set), new Fl(s, r, n);
}
const Mn = {}, Hn = /* @__PURE__ */ new WeakMap();
let $t;
function Dl(e, t = !1, n = $t) {
  if (n) {
    let s = Hn.get(n);
    s || Hn.set(n, s = []), s.push(e);
  }
}
function jl(e, t, n = ue) {
  const { immediate: s, deep: r, once: o, scheduler: i, augmentJob: l, call: c } = n, u = (T) => r ? T : qe(T) || r === !1 || r === 0 ? ht(T, 1) : ht(T);
  let a, d, p, g, v = !1, _ = !1;
  if (Ce(e) ? (d = () => e.value, v = qe(e)) : Jt(e) ? (d = () => u(e), v = !0) : j(e) ? (_ = !0, v = e.some((T) => Jt(T) || qe(T)), d = () => e.map((T) => {
    if (Ce(T))
      return T.value;
    if (Jt(T))
      return u(T);
    if (G(T))
      return c ? c(T, 2) : T();
  })) : G(e) ? t ? d = c ? () => c(e, 2) : e : d = () => {
    if (p) {
      Et();
      try {
        p();
      } finally {
        Tt();
      }
    }
    const T = $t;
    $t = a;
    try {
      return c ? c(e, 3, [g]) : e(g);
    } finally {
      $t = T;
    }
  } : d = lt, t && r) {
    const T = d, H = r === !0 ? 1 / 0 : r;
    d = () => ht(T(), H);
  }
  const A = Co(), L = () => {
    a.stop(), A && A.active && zs(A.effects, a);
  };
  if (o && t) {
    const T = t;
    t = (...H) => {
      T(...H), L();
    };
  }
  let N = _ ? new Array(e.length).fill(Mn) : Mn;
  const F = (T) => {
    if (!(!(a.flags & 1) || !a.dirty && !T))
      if (t) {
        const H = a.run();
        if (r || v || (_ ? H.some((J, Q) => xt(J, N[Q])) : xt(H, N))) {
          p && p();
          const J = $t;
          $t = a;
          try {
            const Q = [
              H,
              // pass undefined as the old value when it's changed for the first time
              N === Mn ? void 0 : _ && N[0] === Mn ? [] : N,
              g
            ];
            c ? c(t, 3, Q) : (
              // @ts-expect-error
              t(...Q)
            ), N = H;
          } finally {
            $t = J;
          }
        }
      } else
        a.run();
  };
  return l && l(F), a = new Eo(d), a.scheduler = i ? () => i(F, !1) : F, g = (T) => Dl(T, !1, a), p = a.onStop = () => {
    const T = Hn.get(a);
    if (T) {
      if (c)
        c(T, 4);
      else
        for (const H of T) H();
      Hn.delete(a);
    }
  }, t ? s ? F(!0) : N = a.run() : i ? i(F.bind(null, !0), !0) : a.run(), L.pause = a.pause.bind(a), L.resume = a.resume.bind(a), L.stop = L, L;
}
function ht(e, t = 1 / 0, n) {
  if (t <= 0 || !he(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, Ce(e))
    ht(e.value, t, n);
  else if (j(e))
    for (let s = 0; s < e.length; s++)
      ht(e[s], t, n);
  else if (go(e) || Gt(e))
    e.forEach((s) => {
      ht(s, t, n);
    });
  else if (Qn(e)) {
    for (const s in e)
      ht(e[s], t, n);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && ht(e[s], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function xn(e, t, n, s) {
  try {
    return s ? e(...s) : e();
  } catch (r) {
    ts(r, t, n);
  }
}
function Qe(e, t, n, s) {
  if (G(e)) {
    const r = xn(e, t, n, s);
    return r && _o(r) && r.catch((o) => {
      ts(o, t, n);
    }), r;
  }
  if (j(e)) {
    const r = [];
    for (let o = 0; o < e.length; o++)
      r.push(Qe(e[o], t, n, s));
    return r;
  }
}
function ts(e, t, n, s = !0) {
  const r = t ? t.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: i } = t && t.appContext.config || ue;
  if (t) {
    let l = t.parent;
    const c = t.proxy, u = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const a = l.ec;
      if (a) {
        for (let d = 0; d < a.length; d++)
          if (a[d](e, c, u) === !1)
            return;
      }
      l = l.parent;
    }
    if (o) {
      Et(), xn(o, null, 10, [
        e,
        c,
        u
      ]), Tt();
      return;
    }
  }
  Hl(e, n, r, s, i);
}
function Hl(e, t, n, s = !0, r = !1) {
  if (r)
    throw e;
  console.error(e);
}
const $e = [];
let st = -1;
const Qt = [];
let yt = null, Wt = 0;
const Vo = /* @__PURE__ */ Promise.resolve();
let Vn = null;
function Pt(e) {
  const t = Vn || Vo;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Vl(e) {
  let t = st + 1, n = $e.length;
  for (; t < n; ) {
    const s = t + n >>> 1, r = $e[s], o = gn(r);
    o < e || o === e && r.flags & 2 ? t = s + 1 : n = s;
  }
  return t;
}
function sr(e) {
  if (!(e.flags & 1)) {
    const t = gn(e), n = $e[$e.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= gn(n) ? $e.push(e) : $e.splice(Vl(t), 0, e), e.flags |= 1, Ko();
  }
}
function Ko() {
  Vn || (Vn = Vo.then(Uo));
}
function Kl(e) {
  j(e) ? Qt.push(...e) : yt && e.id === -1 ? yt.splice(Wt + 1, 0, e) : e.flags & 1 || (Qt.push(e), e.flags |= 1), Ko();
}
function br(e, t, n = st + 1) {
  for (; n < $e.length; n++) {
    const s = $e[n];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid)
        continue;
      $e.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2);
    }
  }
}
function Bo(e) {
  if (Qt.length) {
    const t = [...new Set(Qt)].sort(
      (n, s) => gn(n) - gn(s)
    );
    if (Qt.length = 0, yt) {
      yt.push(...t);
      return;
    }
    for (yt = t, Wt = 0; Wt < yt.length; Wt++) {
      const n = yt[Wt];
      n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2;
    }
    yt = null, Wt = 0;
  }
}
const gn = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Uo(e) {
  try {
    for (st = 0; st < $e.length; st++) {
      const t = $e[st];
      t && !(t.flags & 8) && (t.flags & 4 && (t.flags &= -2), xn(
        t,
        t.i,
        t.i ? 15 : 14
      ), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; st < $e.length; st++) {
      const t = $e[st];
      t && (t.flags &= -2);
    }
    st = -1, $e.length = 0, Bo(), Vn = null, ($e.length || Qt.length) && Uo();
  }
}
let Se = null, Wo = null;
function Kn(e) {
  const t = Se;
  return Se = e, Wo = e && e.type.__scopeId || null, t;
}
function rt(e, t = Se, n) {
  if (!t || e._n)
    return e;
  const s = (...r) => {
    s._d && $r(-1);
    const o = Kn(t);
    let i;
    try {
      i = e(...r);
    } finally {
      Kn(o), s._d && $r(1);
    }
    return i;
  };
  return s._n = !0, s._c = !0, s._d = !0, s;
}
function rr(e, t) {
  if (Se === null)
    return e;
  const n = ls(Se), s = e.dirs || (e.dirs = []);
  for (let r = 0; r < t.length; r++) {
    let [o, i, l, c = ue] = t[r];
    o && (G(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && ht(i), s.push({
      dir: o,
      instance: n,
      value: i,
      oldValue: void 0,
      arg: l,
      modifiers: c
    }));
  }
  return e;
}
function It(e, t, n, s) {
  const r = e.dirs, o = t && t.dirs;
  for (let i = 0; i < r.length; i++) {
    const l = r[i];
    o && (l.oldValue = o[i].value);
    let c = l.dir[s];
    c && (Et(), Qe(c, n, 8, [
      e.el,
      l,
      e,
      t
    ]), Tt());
  }
}
const qo = Symbol("_vte"), zo = (e) => e.__isTeleport, fn = (e) => e && (e.disabled || e.disabled === ""), wr = (e) => e && (e.defer || e.defer === ""), xr = (e) => typeof SVGElement != "undefined" && e instanceof SVGElement, Sr = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, ks = (e, t) => {
  const n = e && e.to;
  return _e(n) ? t ? t(n) : null : n;
}, Go = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, n, s, r, o, i, l, c, u) {
    const {
      mc: a,
      pc: d,
      pbc: p,
      o: { insert: g, querySelector: v, createText: _, createComment: A }
    } = u, L = fn(t.props);
    let { shapeFlag: N, children: F, dynamicChildren: T } = t;
    if (e == null) {
      const H = t.el = _(""), J = t.anchor = _("");
      g(H, n, s), g(J, n, s);
      const Q = (O, W) => {
        N & 16 && (r && r.isCE && (r.ce._teleportTarget = O), a(
          F,
          O,
          W,
          r,
          o,
          i,
          l,
          c
        ));
      }, U = () => {
        const O = t.target = ks(t.props, v), W = Jo(O, t, _, g);
        O && (i !== "svg" && xr(O) ? i = "svg" : i !== "mathml" && Sr(O) && (i = "mathml"), L || (Q(O, W), Rn(t, !1)));
      };
      L && (Q(n, J), Rn(t, !0)), wr(t.props) ? Le(() => {
        U(), t.el.__isMounted = !0;
      }, o) : U();
    } else {
      if (wr(t.props) && !e.el.__isMounted) {
        Le(() => {
          Go.process(
            e,
            t,
            n,
            s,
            r,
            o,
            i,
            l,
            c,
            u
          ), delete e.el.__isMounted;
        }, o);
        return;
      }
      t.el = e.el, t.targetStart = e.targetStart;
      const H = t.anchor = e.anchor, J = t.target = e.target, Q = t.targetAnchor = e.targetAnchor, U = fn(e.props), O = U ? n : J, W = U ? H : Q;
      if (i === "svg" || xr(J) ? i = "svg" : (i === "mathml" || Sr(J)) && (i = "mathml"), T ? (p(
        e.dynamicChildren,
        T,
        O,
        r,
        o,
        i,
        l
      ), lr(e, t, !0)) : c || d(
        e,
        t,
        O,
        W,
        r,
        o,
        i,
        l,
        !1
      ), L)
        U ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : An(
          t,
          n,
          H,
          u,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const Z = t.target = ks(
          t.props,
          v
        );
        Z && An(
          t,
          Z,
          null,
          u,
          0
        );
      } else U && An(
        t,
        J,
        Q,
        u,
        1
      );
      Rn(t, L);
    }
  },
  remove(e, t, n, { um: s, o: { remove: r } }, o) {
    const {
      shapeFlag: i,
      children: l,
      anchor: c,
      targetStart: u,
      targetAnchor: a,
      target: d,
      props: p
    } = e;
    if (d && (r(u), r(a)), o && r(c), i & 16) {
      const g = o || !fn(p);
      for (let v = 0; v < l.length; v++) {
        const _ = l[v];
        s(
          _,
          t,
          n,
          g,
          !!_.dynamicChildren
        );
      }
    }
  },
  move: An,
  hydrate: Bl
};
function An(e, t, n, { o: { insert: s }, m: r }, o = 2) {
  o === 0 && s(e.targetAnchor, t, n);
  const { el: i, anchor: l, shapeFlag: c, children: u, props: a } = e, d = o === 2;
  if (d && s(i, t, n), (!d || fn(a)) && c & 16)
    for (let p = 0; p < u.length; p++)
      r(
        u[p],
        t,
        n,
        2
      );
  d && s(l, t, n);
}
function Bl(e, t, n, s, r, o, {
  o: { nextSibling: i, parentNode: l, querySelector: c, insert: u, createText: a }
}, d) {
  const p = t.target = ks(
    t.props,
    c
  );
  if (p) {
    const g = fn(t.props), v = p._lpa || p.firstChild;
    if (t.shapeFlag & 16)
      if (g)
        t.anchor = d(
          i(e),
          t,
          l(e),
          n,
          s,
          r,
          o
        ), t.targetStart = v, t.targetAnchor = v && i(v);
      else {
        t.anchor = i(e);
        let _ = v;
        for (; _; ) {
          if (_ && _.nodeType === 8) {
            if (_.data === "teleport start anchor")
              t.targetStart = _;
            else if (_.data === "teleport anchor") {
              t.targetAnchor = _, p._lpa = t.targetAnchor && i(t.targetAnchor);
              break;
            }
          }
          _ = i(_);
        }
        t.targetAnchor || Jo(p, t, a, u), d(
          v && i(v),
          t,
          p,
          n,
          s,
          r,
          o
        );
      }
    Rn(t, g);
  }
  return t.anchor && i(t.anchor);
}
const Ul = Go;
function Rn(e, t) {
  const n = e.ctx;
  if (n && n.ut) {
    let s, r;
    for (t ? (s = e.el, r = e.anchor) : (s = e.targetStart, r = e.targetAnchor); s && s !== r; )
      s.nodeType === 1 && s.setAttribute("data-v-owner", n.uid), s = s.nextSibling;
    n.ut();
  }
}
function Jo(e, t, n, s) {
  const r = t.targetStart = n(""), o = t.targetAnchor = n("");
  return r[qo] = o, e && (s(r, e), s(o, e)), o;
}
const bt = Symbol("_leaveCb"), kn = Symbol("_enterCb");
function Wl() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return rs(() => {
    e.isMounted = !0;
  }), Sn(() => {
    e.isUnmounting = !0;
  }), e;
}
const Be = [Function, Array], Qo = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Be,
  onEnter: Be,
  onAfterEnter: Be,
  onEnterCancelled: Be,
  // leave
  onBeforeLeave: Be,
  onLeave: Be,
  onAfterLeave: Be,
  onLeaveCancelled: Be,
  // appear
  onBeforeAppear: Be,
  onAppear: Be,
  onAfterAppear: Be,
  onAppearCancelled: Be
}, Yo = (e) => {
  const t = e.subTree;
  return t.component ? Yo(t.component) : t;
}, ql = {
  name: "BaseTransition",
  props: Qo,
  setup(e, { slots: t }) {
    const n = Vc(), s = Wl();
    return () => {
      const r = t.default && ei(t.default(), !0);
      if (!r || !r.length)
        return;
      const o = Xo(r), i = se(e), { mode: l } = i;
      if (s.isLeaving)
        return ps(o);
      const c = Cr(o);
      if (!c)
        return ps(o);
      let u = Is(
        c,
        i,
        s,
        n,
        // #11061, ensure enterHooks is fresh after clone
        (d) => u = d
      );
      c.type !== Ne && _n(c, u);
      let a = n.subTree && Cr(n.subTree);
      if (a && a.type !== Ne && !Nt(c, a) && Yo(n).type !== Ne) {
        let d = Is(
          a,
          i,
          s,
          n
        );
        if (_n(a, d), l === "out-in" && c.type !== Ne)
          return s.isLeaving = !0, d.afterLeave = () => {
            s.isLeaving = !1, n.job.flags & 8 || n.update(), delete d.afterLeave, a = void 0;
          }, ps(o);
        l === "in-out" && c.type !== Ne ? d.delayLeave = (p, g, v) => {
          const _ = Zo(
            s,
            a
          );
          _[String(a.key)] = a, p[bt] = () => {
            g(), p[bt] = void 0, delete u.delayedLeave, a = void 0;
          }, u.delayedLeave = () => {
            v(), delete u.delayedLeave, a = void 0;
          };
        } : a = void 0;
      } else a && (a = void 0);
      return o;
    };
  }
};
function Xo(e) {
  let t = e[0];
  if (e.length > 1) {
    for (const n of e)
      if (n.type !== Ne) {
        t = n;
        break;
      }
  }
  return t;
}
const zl = ql;
function Zo(e, t) {
  const { leavingVNodes: n } = e;
  let s = n.get(t.type);
  return s || (s = /* @__PURE__ */ Object.create(null), n.set(t.type, s)), s;
}
function Is(e, t, n, s, r) {
  const {
    appear: o,
    mode: i,
    persisted: l = !1,
    onBeforeEnter: c,
    onEnter: u,
    onAfterEnter: a,
    onEnterCancelled: d,
    onBeforeLeave: p,
    onLeave: g,
    onAfterLeave: v,
    onLeaveCancelled: _,
    onBeforeAppear: A,
    onAppear: L,
    onAfterAppear: N,
    onAppearCancelled: F
  } = t, T = String(e.key), H = Zo(n, e), J = (O, W) => {
    O && Qe(
      O,
      s,
      9,
      W
    );
  }, Q = (O, W) => {
    const Z = W[1];
    J(O, W), j(O) ? O.every((E) => E.length <= 1) && Z() : O.length <= 1 && Z();
  }, U = {
    mode: i,
    persisted: l,
    beforeEnter(O) {
      let W = c;
      if (!n.isMounted)
        if (o)
          W = A || c;
        else
          return;
      O[bt] && O[bt](
        !0
        /* cancelled */
      );
      const Z = H[T];
      Z && Nt(e, Z) && Z.el[bt] && Z.el[bt](), J(W, [O]);
    },
    enter(O) {
      let W = u, Z = a, E = d;
      if (!n.isMounted)
        if (o)
          W = L || u, Z = N || a, E = F || d;
        else
          return;
      let B = !1;
      const ae = O[kn] = ($) => {
        B || (B = !0, $ ? J(E, [O]) : J(Z, [O]), U.delayedLeave && U.delayedLeave(), O[kn] = void 0);
      };
      W ? Q(W, [O, ae]) : ae();
    },
    leave(O, W) {
      const Z = String(e.key);
      if (O[kn] && O[kn](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return W();
      J(p, [O]);
      let E = !1;
      const B = O[bt] = (ae) => {
        E || (E = !0, W(), ae ? J(_, [O]) : J(v, [O]), O[bt] = void 0, H[Z] === e && delete H[Z]);
      };
      H[Z] = e, g ? Q(g, [O, B]) : B();
    },
    clone(O) {
      const W = Is(
        O,
        t,
        n,
        s,
        r
      );
      return r && r(W), W;
    }
  };
  return U;
}
function ps(e) {
  if (ns(e))
    return e = Ct(e), e.children = null, e;
}
function Cr(e) {
  if (!ns(e))
    return zo(e.type) && e.children ? Xo(e.children) : e;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16)
      return n[0];
    if (t & 32 && G(n.default))
      return n.default();
  }
}
function _n(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, _n(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function ei(e, t = !1, n) {
  let s = [], r = 0;
  for (let o = 0; o < e.length; o++) {
    let i = e[o];
    const l = n == null ? i.key : String(n) + String(i.key != null ? i.key : o);
    i.type === be ? (i.patchFlag & 128 && r++, s = s.concat(
      ei(i.children, t, l)
    )) : (t || i.type !== Ne) && s.push(l != null ? Ct(i, { key: l }) : i);
  }
  if (r > 1)
    for (let o = 0; o < s.length; o++)
      s[o].patchFlag = -2;
  return s;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function xe(e, t) {
  return G(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    ve({ name: e.name }, t, { setup: e })
  ) : e;
}
function ti(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function Bn(e, t, n, s, r = !1) {
  if (j(e)) {
    e.forEach(
      (v, _) => Bn(
        v,
        t && (j(t) ? t[_] : t),
        n,
        s,
        r
      )
    );
    return;
  }
  if (Yt(s) && !r) {
    s.shapeFlag & 512 && s.type.__asyncResolved && s.component.subTree.component && Bn(e, t, n, s.component.subTree);
    return;
  }
  const o = s.shapeFlag & 4 ? ls(s.component) : s.el, i = r ? null : o, { i: l, r: c } = e, u = t && t.r, a = l.refs === ue ? l.refs = {} : l.refs, d = l.setupState, p = se(d), g = d === ue ? () => !1 : (v) => re(p, v);
  if (u != null && u !== c && (_e(u) ? (a[u] = null, g(u) && (d[u] = null)) : Ce(u) && (u.value = null)), G(c))
    xn(c, l, 12, [i, a]);
  else {
    const v = _e(c), _ = Ce(c);
    if (v || _) {
      const A = () => {
        if (e.f) {
          const L = v ? g(c) ? d[c] : a[c] : c.value;
          r ? j(L) && zs(L, o) : j(L) ? L.includes(o) || L.push(o) : v ? (a[c] = [o], g(c) && (d[c] = a[c])) : (c.value = [o], e.k && (a[e.k] = c.value));
        } else v ? (a[c] = i, g(c) && (d[c] = i)) : _ && (c.value = i, e.k && (a[e.k] = i));
      };
      i ? (A.id = -1, Le(A, n)) : A();
    }
  }
}
Xn().requestIdleCallback;
Xn().cancelIdleCallback;
const Yt = (e) => !!e.type.__asyncLoader, ns = (e) => e.type.__isKeepAlive;
function Gl(e, t) {
  ni(e, "a", t);
}
function Jl(e, t) {
  ni(e, "da", t);
}
function ni(e, t, n = ke) {
  const s = e.__wdc || (e.__wdc = () => {
    let r = n;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (ss(t, s, n), n) {
    let r = n.parent;
    for (; r && r.parent; )
      ns(r.parent.vnode) && Ql(s, t, n, r), r = r.parent;
  }
}
function Ql(e, t, n, s) {
  const r = ss(
    t,
    e,
    s,
    !0
    /* prepend */
  );
  or(() => {
    zs(s[t], r);
  }, n);
}
function ss(e, t, n = ke, s = !1) {
  if (n) {
    const r = n[e] || (n[e] = []), o = t.__weh || (t.__weh = (...i) => {
      Et();
      const l = Cn(n), c = Qe(t, n, e, i);
      return l(), Tt(), c;
    });
    return s ? r.unshift(o) : r.push(o), o;
  }
}
const gt = (e) => (t, n = ke) => {
  (!bn || e === "sp") && ss(e, (...s) => t(...s), n);
}, Yl = gt("bm"), rs = gt("m"), Xl = gt(
  "bu"
), Zl = gt("u"), Sn = gt(
  "bum"
), or = gt("um"), ec = gt(
  "sp"
), tc = gt("rtg"), nc = gt("rtc");
function sc(e, t = ke) {
  ss("ec", e, t);
}
const rc = Symbol.for("v-ndc");
function Er(e, t, n, s) {
  let r;
  const o = n, i = j(e);
  if (i || _e(e)) {
    const l = i && Jt(e);
    let c = !1;
    l && (c = !qe(e), e = es(e)), r = new Array(e.length);
    for (let u = 0, a = e.length; u < a; u++)
      r[u] = t(
        c ? Ae(e[u]) : e[u],
        u,
        void 0,
        o
      );
  } else if (typeof e == "number") {
    r = new Array(e);
    for (let l = 0; l < e; l++)
      r[l] = t(l + 1, l, void 0, o);
  } else if (he(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (l, c) => t(l, c, void 0, o)
      );
    else {
      const l = Object.keys(e);
      r = new Array(l.length);
      for (let c = 0, u = l.length; c < u; c++) {
        const a = l[c];
        r[c] = t(e[a], a, c, o);
      }
    }
  else
    r = [];
  return r;
}
function jt(e, t, n = {}, s, r) {
  if (Se.ce || Se.parent && Yt(Se.parent) && Se.parent.ce)
    return t !== "default" && (n.name = t), X(), He(
      be,
      null,
      [le("slot", n, s)],
      64
    );
  let o = e[t];
  o && o._c && (o._d = !1), X();
  const i = o && si(o(n)), l = n.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  i && i.key, c = He(
    be,
    {
      key: (l && !mt(l) ? l : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    i || [],
    i && e._ === 1 ? 64 : -2
  );
  return c.scopeId && (c.slotScopeIds = [c.scopeId + "-s"]), o && o._c && (o._d = !0), c;
}
function si(e) {
  return e.some((t) => yn(t) ? !(t.type === Ne || t.type === be && !si(t.children)) : !0) ? e : null;
}
const Os = (e) => e ? Si(e) ? ls(e) : Os(e.parent) : null, dn = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ve(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => Os(e.parent),
    $root: (e) => Os(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => oi(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      sr(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Pt.bind(e.proxy)),
    $watch: (e) => Ec.bind(e)
  })
), ms = (e, t) => e !== ue && !e.__isScriptSetup && re(e, t), oc = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: s, data: r, props: o, accessCache: i, type: l, appContext: c } = e;
    let u;
    if (t[0] !== "$") {
      const g = i[t];
      if (g !== void 0)
        switch (g) {
          case 1:
            return s[t];
          case 2:
            return r[t];
          case 4:
            return n[t];
          case 3:
            return o[t];
        }
      else {
        if (ms(s, t))
          return i[t] = 1, s[t];
        if (r !== ue && re(r, t))
          return i[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (u = e.propsOptions[0]) && re(u, t)
        )
          return i[t] = 3, o[t];
        if (n !== ue && re(n, t))
          return i[t] = 4, n[t];
        Ls && (i[t] = 0);
      }
    }
    const a = dn[t];
    let d, p;
    if (a)
      return t === "$attrs" && Me(e.attrs, "get", ""), a(e);
    if (
      // css module (injected by vue-loader)
      (d = l.__cssModules) && (d = d[t])
    )
      return d;
    if (n !== ue && re(n, t))
      return i[t] = 4, n[t];
    if (
      // global properties
      p = c.config.globalProperties, re(p, t)
    )
      return p[t];
  },
  set({ _: e }, t, n) {
    const { data: s, setupState: r, ctx: o } = e;
    return ms(r, t) ? (r[t] = n, !0) : s !== ue && re(s, t) ? (s[t] = n, !0) : re(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (o[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: r, propsOptions: o }
  }, i) {
    let l;
    return !!n[i] || e !== ue && re(e, i) || ms(t, i) || (l = o[0]) && re(l, i) || re(s, i) || re(dn, i) || re(r.config.globalProperties, i);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : re(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function Tr(e) {
  return j(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
let Ls = !0;
function ic(e) {
  const t = oi(e), n = e.proxy, s = e.ctx;
  Ls = !1, t.beforeCreate && Mr(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: o,
    methods: i,
    watch: l,
    provide: c,
    inject: u,
    // lifecycle
    created: a,
    beforeMount: d,
    mounted: p,
    beforeUpdate: g,
    updated: v,
    activated: _,
    deactivated: A,
    beforeDestroy: L,
    beforeUnmount: N,
    destroyed: F,
    unmounted: T,
    render: H,
    renderTracked: J,
    renderTriggered: Q,
    errorCaptured: U,
    serverPrefetch: O,
    // public API
    expose: W,
    inheritAttrs: Z,
    // assets
    components: E,
    directives: B,
    filters: ae
  } = t;
  if (u && lc(u, s, null), i)
    for (const P in i) {
      const Y = i[P];
      G(Y) && (s[P] = Y.bind(n));
    }
  if (r) {
    const P = r.call(n, n);
    he(P) && (e.data = Zt(P));
  }
  if (Ls = !0, o)
    for (const P in o) {
      const Y = o[P], Ee = G(Y) ? Y.bind(n, n) : G(Y.get) ? Y.get.bind(n, n) : lt, ct = !G(Y) && G(Y.set) ? Y.set.bind(n) : lt, Pe = we({
        get: Ee,
        set: ct
      });
      Object.defineProperty(s, P, {
        enumerable: !0,
        configurable: !0,
        get: () => Pe.value,
        set: (Te) => Pe.value = Te
      });
    }
  if (l)
    for (const P in l)
      ri(l[P], s, n, P);
  if (c) {
    const P = G(c) ? c.call(n) : c;
    Reflect.ownKeys(P).forEach((Y) => {
      li(Y, P[Y]);
    });
  }
  a && Mr(a, e, "c");
  function K(P, Y) {
    j(Y) ? Y.forEach((Ee) => P(Ee.bind(n))) : Y && P(Y.bind(n));
  }
  if (K(Yl, d), K(rs, p), K(Xl, g), K(Zl, v), K(Gl, _), K(Jl, A), K(sc, U), K(nc, J), K(tc, Q), K(Sn, N), K(or, T), K(ec, O), j(W))
    if (W.length) {
      const P = e.exposed || (e.exposed = {});
      W.forEach((Y) => {
        Object.defineProperty(P, Y, {
          get: () => n[Y],
          set: (Ee) => n[Y] = Ee
        });
      });
    } else e.exposed || (e.exposed = {});
  H && e.render === lt && (e.render = H), Z != null && (e.inheritAttrs = Z), E && (e.components = E), B && (e.directives = B), O && ti(e);
}
function lc(e, t, n = lt) {
  j(e) && (e = Rs(e));
  for (const s in e) {
    const r = e[s];
    let o;
    he(r) ? "default" in r ? o = $n(
      r.from || s,
      r.default,
      !0
    ) : o = $n(r.from || s) : o = $n(r), Ce(o) ? Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => o.value,
      set: (i) => o.value = i
    }) : t[s] = o;
  }
}
function Mr(e, t, n) {
  Qe(
    j(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function ri(e, t, n, s) {
  let r = s.includes(".") ? vi(n, s) : () => n[s];
  if (_e(e)) {
    const o = t[e];
    G(o) && We(r, o);
  } else if (G(e))
    We(r, e.bind(n));
  else if (he(e))
    if (j(e))
      e.forEach((o) => ri(o, t, n, s));
    else {
      const o = G(e.handler) ? e.handler.bind(n) : t[e.handler];
      G(o) && We(r, o, e);
    }
}
function oi(e) {
  const t = e.type, { mixins: n, extends: s } = t, {
    mixins: r,
    optionsCache: o,
    config: { optionMergeStrategies: i }
  } = e.appContext, l = o.get(t);
  let c;
  return l ? c = l : !r.length && !n && !s ? c = t : (c = {}, r.length && r.forEach(
    (u) => Un(c, u, i, !0)
  ), Un(c, t, i)), he(t) && o.set(t, c), c;
}
function Un(e, t, n, s = !1) {
  const { mixins: r, extends: o } = t;
  o && Un(e, o, n, !0), r && r.forEach(
    (i) => Un(e, i, n, !0)
  );
  for (const i in t)
    if (!(s && i === "expose")) {
      const l = cc[i] || n && n[i];
      e[i] = l ? l(e[i], t[i]) : t[i];
    }
  return e;
}
const cc = {
  data: Ar,
  props: kr,
  emits: kr,
  // objects
  methods: ln,
  computed: ln,
  // lifecycle
  beforeCreate: Oe,
  created: Oe,
  beforeMount: Oe,
  mounted: Oe,
  beforeUpdate: Oe,
  updated: Oe,
  beforeDestroy: Oe,
  beforeUnmount: Oe,
  destroyed: Oe,
  unmounted: Oe,
  activated: Oe,
  deactivated: Oe,
  errorCaptured: Oe,
  serverPrefetch: Oe,
  // assets
  components: ln,
  directives: ln,
  // watch
  watch: uc,
  // provide / inject
  provide: Ar,
  inject: ac
};
function Ar(e, t) {
  return t ? e ? function() {
    return ve(
      G(e) ? e.call(this, this) : e,
      G(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function ac(e, t) {
  return ln(Rs(e), Rs(t));
}
function Rs(e) {
  if (j(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Oe(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function ln(e, t) {
  return e ? ve(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function kr(e, t) {
  return e ? j(e) && j(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ve(
    /* @__PURE__ */ Object.create(null),
    Tr(e),
    Tr(t != null ? t : {})
  ) : t;
}
function uc(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = ve(/* @__PURE__ */ Object.create(null), e);
  for (const s in t)
    n[s] = Oe(e[s], t[s]);
  return n;
}
function ii() {
  return {
    app: null,
    config: {
      isNativeTag: Qi,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let fc = 0;
function dc(e, t) {
  return function(s, r = null) {
    G(s) || (s = ve({}, s)), r != null && !he(r) && (r = null);
    const o = ii(), i = /* @__PURE__ */ new WeakSet(), l = [];
    let c = !1;
    const u = o.app = {
      _uid: fc++,
      _component: s,
      _props: r,
      _container: null,
      _context: o,
      _instance: null,
      version: zc,
      get config() {
        return o.config;
      },
      set config(a) {
      },
      use(a, ...d) {
        return i.has(a) || (a && G(a.install) ? (i.add(a), a.install(u, ...d)) : G(a) && (i.add(a), a(u, ...d))), u;
      },
      mixin(a) {
        return o.mixins.includes(a) || o.mixins.push(a), u;
      },
      component(a, d) {
        return d ? (o.components[a] = d, u) : o.components[a];
      },
      directive(a, d) {
        return d ? (o.directives[a] = d, u) : o.directives[a];
      },
      mount(a, d, p) {
        if (!c) {
          const g = u._ceVNode || le(s, r);
          return g.appContext = o, p === !0 ? p = "svg" : p === !1 && (p = void 0), e(g, a, p), c = !0, u._container = a, a.__vue_app__ = u, ls(g.component);
        }
      },
      onUnmount(a) {
        l.push(a);
      },
      unmount() {
        c && (Qe(
          l,
          u._instance,
          16
        ), e(null, u._container), delete u._container.__vue_app__);
      },
      provide(a, d) {
        return o.provides[a] = d, u;
      },
      runWithContext(a) {
        const d = Xt;
        Xt = u;
        try {
          return a();
        } finally {
          Xt = d;
        }
      }
    };
    return u;
  };
}
let Xt = null;
function li(e, t) {
  if (ke) {
    let n = ke.provides;
    const s = ke.parent && ke.parent.provides;
    s === n && (n = ke.provides = Object.create(s)), n[e] = t;
  }
}
function $n(e, t, n = !1) {
  const s = ke || Se;
  if (s || Xt) {
    const r = Xt ? Xt._context.provides : s ? s.parent == null ? s.vnode.appContext && s.vnode.appContext.provides : s.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return n && G(t) ? t.call(s && s.proxy) : t;
  }
}
const ci = {}, ai = () => Object.create(ci), ui = (e) => Object.getPrototypeOf(e) === ci;
function hc(e, t, n, s = !1) {
  const r = {}, o = ai();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), fi(e, t, r, o);
  for (const i in e.propsOptions[0])
    i in r || (r[i] = void 0);
  n ? e.props = s ? r : Al(r) : e.type.props ? e.props = r : e.props = o, e.attrs = o;
}
function pc(e, t, n, s) {
  const {
    props: r,
    attrs: o,
    vnode: { patchFlag: i }
  } = e, l = se(r), [c] = e.propsOptions;
  let u = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (s || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const a = e.vnode.dynamicProps;
      for (let d = 0; d < a.length; d++) {
        let p = a[d];
        if (os(e.emitsOptions, p))
          continue;
        const g = t[p];
        if (c)
          if (re(o, p))
            g !== o[p] && (o[p] = g, u = !0);
          else {
            const v = Ge(p);
            r[v] = $s(
              c,
              l,
              v,
              g,
              e,
              !1
            );
          }
        else
          g !== o[p] && (o[p] = g, u = !0);
      }
    }
  } else {
    fi(e, t, r, o) && (u = !0);
    let a;
    for (const d in l)
      (!t || // for camelCase
      !re(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((a = Ue(d)) === d || !re(t, a))) && (c ? n && // for camelCase
      (n[d] !== void 0 || // for kebab-case
      n[a] !== void 0) && (r[d] = $s(
        c,
        l,
        d,
        void 0,
        e,
        !0
      )) : delete r[d]);
    if (o !== l)
      for (const d in o)
        (!t || !re(t, d)) && (delete o[d], u = !0);
  }
  u && dt(e.attrs, "set", "");
}
function fi(e, t, n, s) {
  const [r, o] = e.propsOptions;
  let i = !1, l;
  if (t)
    for (let c in t) {
      if (cn(c))
        continue;
      const u = t[c];
      let a;
      r && re(r, a = Ge(c)) ? !o || !o.includes(a) ? n[a] = u : (l || (l = {}))[a] = u : os(e.emitsOptions, c) || (!(c in s) || u !== s[c]) && (s[c] = u, i = !0);
    }
  if (o) {
    const c = se(n), u = l || ue;
    for (let a = 0; a < o.length; a++) {
      const d = o[a];
      n[d] = $s(
        r,
        c,
        d,
        u[d],
        e,
        !re(u, d)
      );
    }
  }
  return i;
}
function $s(e, t, n, s, r, o) {
  const i = e[n];
  if (i != null) {
    const l = re(i, "default");
    if (l && s === void 0) {
      const c = i.default;
      if (i.type !== Function && !i.skipFactory && G(c)) {
        const { propsDefaults: u } = r;
        if (n in u)
          s = u[n];
        else {
          const a = Cn(r);
          s = u[n] = c.call(
            null,
            t
          ), a();
        }
      } else
        s = c;
      r.ce && r.ce._setProp(n, s);
    }
    i[
      0
      /* shouldCast */
    ] && (o && !l ? s = !1 : i[
      1
      /* shouldCastTrue */
    ] && (s === "" || s === Ue(n)) && (s = !0));
  }
  return s;
}
const mc = /* @__PURE__ */ new WeakMap();
function di(e, t, n = !1) {
  const s = n ? mc : t.propsCache, r = s.get(e);
  if (r)
    return r;
  const o = e.props, i = {}, l = [];
  let c = !1;
  if (!G(e)) {
    const a = (d) => {
      c = !0;
      const [p, g] = di(d, t, !0);
      ve(i, p), g && l.push(...g);
    };
    !n && t.mixins.length && t.mixins.forEach(a), e.extends && a(e.extends), e.mixins && e.mixins.forEach(a);
  }
  if (!o && !c)
    return he(e) && s.set(e, zt), zt;
  if (j(o))
    for (let a = 0; a < o.length; a++) {
      const d = Ge(o[a]);
      Ir(d) && (i[d] = ue);
    }
  else if (o)
    for (const a in o) {
      const d = Ge(a);
      if (Ir(d)) {
        const p = o[a], g = i[d] = j(p) || G(p) ? { type: p } : ve({}, p), v = g.type;
        let _ = !1, A = !0;
        if (j(v))
          for (let L = 0; L < v.length; ++L) {
            const N = v[L], F = G(N) && N.name;
            if (F === "Boolean") {
              _ = !0;
              break;
            } else F === "String" && (A = !1);
          }
        else
          _ = G(v) && v.name === "Boolean";
        g[
          0
          /* shouldCast */
        ] = _, g[
          1
          /* shouldCastTrue */
        ] = A, (_ || re(g, "default")) && l.push(d);
      }
    }
  const u = [i, l];
  return he(e) && s.set(e, u), u;
}
function Ir(e) {
  return e[0] !== "$" && !cn(e);
}
const hi = (e) => e[0] === "_" || e === "$stable", ir = (e) => j(e) ? e.map(ot) : [ot(e)], gc = (e, t, n) => {
  if (t._n)
    return t;
  const s = rt((...r) => ir(t(...r)), n);
  return s._c = !1, s;
}, pi = (e, t, n) => {
  const s = e._ctx;
  for (const r in e) {
    if (hi(r)) continue;
    const o = e[r];
    if (G(o))
      t[r] = gc(r, o, s);
    else if (o != null) {
      const i = ir(o);
      t[r] = () => i;
    }
  }
}, mi = (e, t) => {
  const n = ir(t);
  e.slots.default = () => n;
}, gi = (e, t, n) => {
  for (const s in t)
    (n || s !== "_") && (e[s] = t[s]);
}, _c = (e, t, n) => {
  const s = e.slots = ai();
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (gi(s, t, n), n && bo(s, "_", r, !0)) : pi(t, s);
  } else t && mi(e, t);
}, vc = (e, t, n) => {
  const { vnode: s, slots: r } = e;
  let o = !0, i = ue;
  if (s.shapeFlag & 32) {
    const l = t._;
    l ? n && l === 1 ? o = !1 : gi(r, t, n) : (o = !t.$stable, pi(t, r)), i = t;
  } else t && (mi(e, t), i = { default: 1 });
  if (o)
    for (const l in r)
      !hi(l) && i[l] == null && delete r[l];
}, Le = Lc;
function yc(e) {
  return bc(e);
}
function bc(e, t) {
  const n = Xn();
  n.__VUE__ = !0;
  const {
    insert: s,
    remove: r,
    patchProp: o,
    createElement: i,
    createText: l,
    createComment: c,
    setText: u,
    setElementText: a,
    parentNode: d,
    nextSibling: p,
    setScopeId: g = lt,
    insertStaticContent: v
  } = e, _ = (f, h, m, b = null, y = null, w = null, M = void 0, C = null, S = !!h.dynamicChildren) => {
    if (f === h)
      return;
    f && !Nt(f, h) && (b = oe(f), Te(f, y, w, !0), f = null), h.patchFlag === -2 && (S = !1, h.dynamicChildren = null);
    const { type: x, ref: V, shapeFlag: k } = h;
    switch (x) {
      case is:
        A(f, h, m, b);
        break;
      case Ne:
        L(f, h, m, b);
        break;
      case Nn:
        f == null && N(h, m, b, M);
        break;
      case be:
        E(
          f,
          h,
          m,
          b,
          y,
          w,
          M,
          C,
          S
        );
        break;
      default:
        k & 1 ? H(
          f,
          h,
          m,
          b,
          y,
          w,
          M,
          C,
          S
        ) : k & 6 ? B(
          f,
          h,
          m,
          b,
          y,
          w,
          M,
          C,
          S
        ) : (k & 64 || k & 128) && x.process(
          f,
          h,
          m,
          b,
          y,
          w,
          M,
          C,
          S,
          Xe
        );
    }
    V != null && y && Bn(V, f && f.ref, w, h || f, !h);
  }, A = (f, h, m, b) => {
    if (f == null)
      s(
        h.el = l(h.children),
        m,
        b
      );
    else {
      const y = h.el = f.el;
      h.children !== f.children && u(y, h.children);
    }
  }, L = (f, h, m, b) => {
    f == null ? s(
      h.el = c(h.children || ""),
      m,
      b
    ) : h.el = f.el;
  }, N = (f, h, m, b) => {
    [f.el, f.anchor] = v(
      f.children,
      h,
      m,
      b,
      f.el,
      f.anchor
    );
  }, F = ({ el: f, anchor: h }, m, b) => {
    let y;
    for (; f && f !== h; )
      y = p(f), s(f, m, b), f = y;
    s(h, m, b);
  }, T = ({ el: f, anchor: h }) => {
    let m;
    for (; f && f !== h; )
      m = p(f), r(f), f = m;
    r(h);
  }, H = (f, h, m, b, y, w, M, C, S) => {
    h.type === "svg" ? M = "svg" : h.type === "math" && (M = "mathml"), f == null ? J(
      h,
      m,
      b,
      y,
      w,
      M,
      C,
      S
    ) : O(
      f,
      h,
      y,
      w,
      M,
      C,
      S
    );
  }, J = (f, h, m, b, y, w, M, C) => {
    let S, x;
    const { props: V, shapeFlag: k, transition: D, dirs: q } = f;
    if (S = f.el = i(
      f.type,
      w,
      V && V.is,
      V
    ), k & 8 ? a(S, f.children) : k & 16 && U(
      f.children,
      S,
      null,
      b,
      y,
      gs(f, w),
      M,
      C
    ), q && It(f, null, b, "created"), Q(S, f, f.scopeId, M, b), V) {
      for (const fe in V)
        fe !== "value" && !cn(fe) && o(S, fe, null, V[fe], w, b);
      "value" in V && o(S, "value", null, V.value, w), (x = V.onVnodeBeforeMount) && nt(x, b, f);
    }
    q && It(f, null, b, "beforeMount");
    const ne = wc(y, D);
    ne && D.beforeEnter(S), s(S, h, m), ((x = V && V.onVnodeMounted) || ne || q) && Le(() => {
      x && nt(x, b, f), ne && D.enter(S), q && It(f, null, b, "mounted");
    }, y);
  }, Q = (f, h, m, b, y) => {
    if (m && g(f, m), b)
      for (let w = 0; w < b.length; w++)
        g(f, b[w]);
    if (y) {
      let w = y.subTree;
      if (h === w || bi(w.type) && (w.ssContent === h || w.ssFallback === h)) {
        const M = y.vnode;
        Q(
          f,
          M,
          M.scopeId,
          M.slotScopeIds,
          y.parent
        );
      }
    }
  }, U = (f, h, m, b, y, w, M, C, S = 0) => {
    for (let x = S; x < f.length; x++) {
      const V = f[x] = C ? wt(f[x]) : ot(f[x]);
      _(
        null,
        V,
        h,
        m,
        b,
        y,
        w,
        M,
        C
      );
    }
  }, O = (f, h, m, b, y, w, M) => {
    const C = h.el = f.el;
    let { patchFlag: S, dynamicChildren: x, dirs: V } = h;
    S |= f.patchFlag & 16;
    const k = f.props || ue, D = h.props || ue;
    let q;
    if (m && Ot(m, !1), (q = D.onVnodeBeforeUpdate) && nt(q, m, h, f), V && It(h, f, m, "beforeUpdate"), m && Ot(m, !0), (k.innerHTML && D.innerHTML == null || k.textContent && D.textContent == null) && a(C, ""), x ? W(
      f.dynamicChildren,
      x,
      C,
      m,
      b,
      gs(h, y),
      w
    ) : M || Y(
      f,
      h,
      C,
      null,
      m,
      b,
      gs(h, y),
      w,
      !1
    ), S > 0) {
      if (S & 16)
        Z(C, k, D, m, y);
      else if (S & 2 && k.class !== D.class && o(C, "class", null, D.class, y), S & 4 && o(C, "style", k.style, D.style, y), S & 8) {
        const ne = h.dynamicProps;
        for (let fe = 0; fe < ne.length; fe++) {
          const ie = ne[fe], De = k[ie], Fe = D[ie];
          (Fe !== De || ie === "value") && o(C, ie, De, Fe, y, m);
        }
      }
      S & 1 && f.children !== h.children && a(C, h.children);
    } else !M && x == null && Z(C, k, D, m, y);
    ((q = D.onVnodeUpdated) || V) && Le(() => {
      q && nt(q, m, h, f), V && It(h, f, m, "updated");
    }, b);
  }, W = (f, h, m, b, y, w, M) => {
    for (let C = 0; C < h.length; C++) {
      const S = f[C], x = h[C], V = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        S.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (S.type === be || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Nt(S, x) || // - In the case of a component, it could contain anything.
        S.shapeFlag & 70) ? d(S.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          m
        )
      );
      _(
        S,
        x,
        V,
        null,
        b,
        y,
        w,
        M,
        !0
      );
    }
  }, Z = (f, h, m, b, y) => {
    if (h !== m) {
      if (h !== ue)
        for (const w in h)
          !cn(w) && !(w in m) && o(
            f,
            w,
            h[w],
            null,
            y,
            b
          );
      for (const w in m) {
        if (cn(w)) continue;
        const M = m[w], C = h[w];
        M !== C && w !== "value" && o(f, w, C, M, y, b);
      }
      "value" in m && o(f, "value", h.value, m.value, y);
    }
  }, E = (f, h, m, b, y, w, M, C, S) => {
    const x = h.el = f ? f.el : l(""), V = h.anchor = f ? f.anchor : l("");
    let { patchFlag: k, dynamicChildren: D, slotScopeIds: q } = h;
    q && (C = C ? C.concat(q) : q), f == null ? (s(x, m, b), s(V, m, b), U(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      h.children || [],
      m,
      V,
      y,
      w,
      M,
      C,
      S
    )) : k > 0 && k & 64 && D && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    f.dynamicChildren ? (W(
      f.dynamicChildren,
      D,
      m,
      y,
      w,
      M,
      C
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (h.key != null || y && h === y.subTree) && lr(
      f,
      h,
      !0
      /* shallow */
    )) : Y(
      f,
      h,
      m,
      V,
      y,
      w,
      M,
      C,
      S
    );
  }, B = (f, h, m, b, y, w, M, C, S) => {
    h.slotScopeIds = C, f == null ? h.shapeFlag & 512 ? y.ctx.activate(
      h,
      m,
      b,
      M,
      S
    ) : ae(
      h,
      m,
      b,
      y,
      w,
      M,
      S
    ) : $(f, h, S);
  }, ae = (f, h, m, b, y, w, M) => {
    const C = f.component = Hc(
      f,
      b,
      y
    );
    if (ns(f) && (C.ctx.renderer = Xe), Kc(C, !1, M), C.asyncDep) {
      if (y && y.registerDep(C, K, M), !f.el) {
        const S = C.subTree = le(Ne);
        L(null, S, h, m);
      }
    } else
      K(
        C,
        f,
        h,
        m,
        y,
        w,
        M
      );
  }, $ = (f, h, m) => {
    const b = h.component = f.component;
    if (Ic(f, h, m))
      if (b.asyncDep && !b.asyncResolved) {
        P(b, h, m);
        return;
      } else
        b.next = h, b.update();
    else
      h.el = f.el, b.vnode = h;
  }, K = (f, h, m, b, y, w, M) => {
    const C = () => {
      if (f.isMounted) {
        let { next: k, bu: D, u: q, parent: ne, vnode: fe } = f;
        {
          const et = _i(f);
          if (et) {
            k && (k.el = fe.el, P(f, k, M)), et.asyncDep.then(() => {
              f.isUnmounted || C();
            });
            return;
          }
        }
        let ie = k, De;
        Ot(f, !1), k ? (k.el = fe.el, P(f, k, M)) : k = fe, D && Ln(D), (De = k.props && k.props.onVnodeBeforeUpdate) && nt(De, ne, k, fe), Ot(f, !0);
        const Fe = Lr(f), Ze = f.subTree;
        f.subTree = Fe, _(
          Ze,
          Fe,
          // parent may have changed if it's in a teleport
          d(Ze.el),
          // anchor may have changed if it's in a fragment
          oe(Ze),
          f,
          y,
          w
        ), k.el = Fe.el, ie === null && Oc(f, Fe.el), q && Le(q, y), (De = k.props && k.props.onVnodeUpdated) && Le(
          () => nt(De, ne, k, fe),
          y
        );
      } else {
        let k;
        const { el: D, props: q } = h, { bm: ne, m: fe, parent: ie, root: De, type: Fe } = f, Ze = Yt(h);
        Ot(f, !1), ne && Ln(ne), !Ze && (k = q && q.onVnodeBeforeMount) && nt(k, ie, h), Ot(f, !0);
        {
          De.ce && De.ce._injectChildStyle(Fe);
          const et = f.subTree = Lr(f);
          _(
            null,
            et,
            m,
            b,
            f,
            y,
            w
          ), h.el = et.el;
        }
        if (fe && Le(fe, y), !Ze && (k = q && q.onVnodeMounted)) {
          const et = h;
          Le(
            () => nt(k, ie, et),
            y
          );
        }
        (h.shapeFlag & 256 || ie && Yt(ie.vnode) && ie.vnode.shapeFlag & 256) && f.a && Le(f.a, y), f.isMounted = !0, h = m = b = null;
      }
    };
    f.scope.on();
    const S = f.effect = new Eo(C);
    f.scope.off();
    const x = f.update = S.run.bind(S), V = f.job = S.runIfDirty.bind(S);
    V.i = f, V.id = f.uid, S.scheduler = () => sr(V), Ot(f, !0), x();
  }, P = (f, h, m) => {
    h.component = f;
    const b = f.vnode.props;
    f.vnode = h, f.next = null, pc(f, h.props, b, m), vc(f, h.children, m), Et(), br(f), Tt();
  }, Y = (f, h, m, b, y, w, M, C, S = !1) => {
    const x = f && f.children, V = f ? f.shapeFlag : 0, k = h.children, { patchFlag: D, shapeFlag: q } = h;
    if (D > 0) {
      if (D & 128) {
        ct(
          x,
          k,
          m,
          b,
          y,
          w,
          M,
          C,
          S
        );
        return;
      } else if (D & 256) {
        Ee(
          x,
          k,
          m,
          b,
          y,
          w,
          M,
          C,
          S
        );
        return;
      }
    }
    q & 8 ? (V & 16 && ee(x, y, w), k !== x && a(m, k)) : V & 16 ? q & 16 ? ct(
      x,
      k,
      m,
      b,
      y,
      w,
      M,
      C,
      S
    ) : ee(x, y, w, !0) : (V & 8 && a(m, ""), q & 16 && U(
      k,
      m,
      b,
      y,
      w,
      M,
      C,
      S
    ));
  }, Ee = (f, h, m, b, y, w, M, C, S) => {
    f = f || zt, h = h || zt;
    const x = f.length, V = h.length, k = Math.min(x, V);
    let D;
    for (D = 0; D < k; D++) {
      const q = h[D] = S ? wt(h[D]) : ot(h[D]);
      _(
        f[D],
        q,
        m,
        null,
        y,
        w,
        M,
        C,
        S
      );
    }
    x > V ? ee(
      f,
      y,
      w,
      !0,
      !1,
      k
    ) : U(
      h,
      m,
      b,
      y,
      w,
      M,
      C,
      S,
      k
    );
  }, ct = (f, h, m, b, y, w, M, C, S) => {
    let x = 0;
    const V = h.length;
    let k = f.length - 1, D = V - 1;
    for (; x <= k && x <= D; ) {
      const q = f[x], ne = h[x] = S ? wt(h[x]) : ot(h[x]);
      if (Nt(q, ne))
        _(
          q,
          ne,
          m,
          null,
          y,
          w,
          M,
          C,
          S
        );
      else
        break;
      x++;
    }
    for (; x <= k && x <= D; ) {
      const q = f[k], ne = h[D] = S ? wt(h[D]) : ot(h[D]);
      if (Nt(q, ne))
        _(
          q,
          ne,
          m,
          null,
          y,
          w,
          M,
          C,
          S
        );
      else
        break;
      k--, D--;
    }
    if (x > k) {
      if (x <= D) {
        const q = D + 1, ne = q < V ? h[q].el : b;
        for (; x <= D; )
          _(
            null,
            h[x] = S ? wt(h[x]) : ot(h[x]),
            m,
            ne,
            y,
            w,
            M,
            C,
            S
          ), x++;
      }
    } else if (x > D)
      for (; x <= k; )
        Te(f[x], y, w, !0), x++;
    else {
      const q = x, ne = x, fe = /* @__PURE__ */ new Map();
      for (x = ne; x <= D; x++) {
        const je = h[x] = S ? wt(h[x]) : ot(h[x]);
        je.key != null && fe.set(je.key, x);
      }
      let ie, De = 0;
      const Fe = D - ne + 1;
      let Ze = !1, et = 0;
      const nn = new Array(Fe);
      for (x = 0; x < Fe; x++) nn[x] = 0;
      for (x = q; x <= k; x++) {
        const je = f[x];
        if (De >= Fe) {
          Te(je, y, w, !0);
          continue;
        }
        let tt;
        if (je.key != null)
          tt = fe.get(je.key);
        else
          for (ie = ne; ie <= D; ie++)
            if (nn[ie - ne] === 0 && Nt(je, h[ie])) {
              tt = ie;
              break;
            }
        tt === void 0 ? Te(je, y, w, !0) : (nn[tt - ne] = x + 1, tt >= et ? et = tt : Ze = !0, _(
          je,
          h[tt],
          m,
          null,
          y,
          w,
          M,
          C,
          S
        ), De++);
      }
      const hr = Ze ? xc(nn) : zt;
      for (ie = hr.length - 1, x = Fe - 1; x >= 0; x--) {
        const je = ne + x, tt = h[je], pr = je + 1 < V ? h[je + 1].el : b;
        nn[x] === 0 ? _(
          null,
          tt,
          m,
          pr,
          y,
          w,
          M,
          C,
          S
        ) : Ze && (ie < 0 || x !== hr[ie] ? Pe(tt, m, pr, 2) : ie--);
      }
    }
  }, Pe = (f, h, m, b, y = null) => {
    const { el: w, type: M, transition: C, children: S, shapeFlag: x } = f;
    if (x & 6) {
      Pe(f.component.subTree, h, m, b);
      return;
    }
    if (x & 128) {
      f.suspense.move(h, m, b);
      return;
    }
    if (x & 64) {
      M.move(f, h, m, Xe);
      return;
    }
    if (M === be) {
      s(w, h, m);
      for (let k = 0; k < S.length; k++)
        Pe(S[k], h, m, b);
      s(f.anchor, h, m);
      return;
    }
    if (M === Nn) {
      F(f, h, m);
      return;
    }
    if (b !== 2 && x & 1 && C)
      if (b === 0)
        C.beforeEnter(w), s(w, h, m), Le(() => C.enter(w), y);
      else {
        const { leave: k, delayLeave: D, afterLeave: q } = C, ne = () => s(w, h, m), fe = () => {
          k(w, () => {
            ne(), q && q();
          });
        };
        D ? D(w, ne, fe) : fe();
      }
    else
      s(w, h, m);
  }, Te = (f, h, m, b = !1, y = !1) => {
    const {
      type: w,
      props: M,
      ref: C,
      children: S,
      dynamicChildren: x,
      shapeFlag: V,
      patchFlag: k,
      dirs: D,
      cacheIndex: q
    } = f;
    if (k === -2 && (y = !1), C != null && Bn(C, null, m, f, !0), q != null && (h.renderCache[q] = void 0), V & 256) {
      h.ctx.deactivate(f);
      return;
    }
    const ne = V & 1 && D, fe = !Yt(f);
    let ie;
    if (fe && (ie = M && M.onVnodeBeforeUnmount) && nt(ie, h, f), V & 6)
      te(f.component, m, b);
    else {
      if (V & 128) {
        f.suspense.unmount(m, b);
        return;
      }
      ne && It(f, null, h, "beforeUnmount"), V & 64 ? f.type.remove(
        f,
        h,
        m,
        Xe,
        b
      ) : x && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !x.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (w !== be || k > 0 && k & 64) ? ee(
        x,
        h,
        m,
        !1,
        !0
      ) : (w === be && k & 384 || !y && V & 16) && ee(S, h, m), b && At(f);
    }
    (fe && (ie = M && M.onVnodeUnmounted) || ne) && Le(() => {
      ie && nt(ie, h, f), ne && It(f, null, h, "unmounted");
    }, m);
  }, At = (f) => {
    const { type: h, el: m, anchor: b, transition: y } = f;
    if (h === be) {
      I(m, b);
      return;
    }
    if (h === Nn) {
      T(f);
      return;
    }
    const w = () => {
      r(m), y && !y.persisted && y.afterLeave && y.afterLeave();
    };
    if (f.shapeFlag & 1 && y && !y.persisted) {
      const { leave: M, delayLeave: C } = y, S = () => M(m, w);
      C ? C(f.el, w, S) : S();
    } else
      w();
  }, I = (f, h) => {
    let m;
    for (; f !== h; )
      m = p(f), r(f), f = m;
    r(h);
  }, te = (f, h, m) => {
    const { bum: b, scope: y, job: w, subTree: M, um: C, m: S, a: x } = f;
    Or(S), Or(x), b && Ln(b), y.stop(), w && (w.flags |= 8, Te(M, f, h, m)), C && Le(C, h), Le(() => {
      f.isUnmounted = !0;
    }, h), h && h.pendingBranch && !h.isUnmounted && f.asyncDep && !f.asyncResolved && f.suspenseId === h.pendingId && (h.deps--, h.deps === 0 && h.resolve());
  }, ee = (f, h, m, b = !1, y = !1, w = 0) => {
    for (let M = w; M < f.length; M++)
      Te(f[M], h, m, b, y);
  }, oe = (f) => {
    if (f.shapeFlag & 6)
      return oe(f.component.subTree);
    if (f.shapeFlag & 128)
      return f.suspense.next();
    const h = p(f.anchor || f.el), m = h && h[qo];
    return m ? p(m) : h;
  };
  let Ie = !1;
  const Ye = (f, h, m) => {
    f == null ? h._vnode && Te(h._vnode, null, null, !0) : _(
      h._vnode || null,
      f,
      h,
      null,
      null,
      null,
      m
    ), h._vnode = f, Ie || (Ie = !0, br(), Bo(), Ie = !1);
  }, Xe = {
    p: _,
    um: Te,
    m: Pe,
    r: At,
    mt: ae,
    mc: U,
    pc: Y,
    pbc: W,
    n: oe,
    o: e
  };
  return {
    render: Ye,
    hydrate: void 0,
    createApp: dc(Ye)
  };
}
function gs({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function Ot({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function wc(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function lr(e, t, n = !1) {
  const s = e.children, r = t.children;
  if (j(s) && j(r))
    for (let o = 0; o < s.length; o++) {
      const i = s[o];
      let l = r[o];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = r[o] = wt(r[o]), l.el = i.el), !n && l.patchFlag !== -2 && lr(i, l)), l.type === is && (l.el = i.el);
    }
}
function xc(e) {
  const t = e.slice(), n = [0];
  let s, r, o, i, l;
  const c = e.length;
  for (s = 0; s < c; s++) {
    const u = e[s];
    if (u !== 0) {
      if (r = n[n.length - 1], e[r] < u) {
        t[s] = r, n.push(s);
        continue;
      }
      for (o = 0, i = n.length - 1; o < i; )
        l = o + i >> 1, e[n[l]] < u ? o = l + 1 : i = l;
      u < e[n[o]] && (o > 0 && (t[s] = n[o - 1]), n[o] = s);
    }
  }
  for (o = n.length, i = n[o - 1]; o-- > 0; )
    n[o] = i, i = t[i];
  return n;
}
function _i(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : _i(t);
}
function Or(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const Sc = Symbol.for("v-scx"), Cc = () => $n(Sc);
function cr(e, t) {
  return ar(e, null, t);
}
function We(e, t, n) {
  return ar(e, t, n);
}
function ar(e, t, n = ue) {
  const { immediate: s, deep: r, flush: o, once: i } = n, l = ve({}, n), c = t && s || !t && o !== "post";
  let u;
  if (bn) {
    if (o === "sync") {
      const g = Cc();
      u = g.__watcherHandles || (g.__watcherHandles = []);
    } else if (!c) {
      const g = () => {
      };
      return g.stop = lt, g.resume = lt, g.pause = lt, g;
    }
  }
  const a = ke;
  l.call = (g, v, _) => Qe(g, a, v, _);
  let d = !1;
  o === "post" ? l.scheduler = (g) => {
    Le(g, a && a.suspense);
  } : o !== "sync" && (d = !0, l.scheduler = (g, v) => {
    v ? g() : sr(g);
  }), l.augmentJob = (g) => {
    t && (g.flags |= 4), d && (g.flags |= 2, a && (g.id = a.uid, g.i = a));
  };
  const p = jl(e, t, l);
  return bn && (u ? u.push(p) : c && p()), p;
}
function Ec(e, t, n) {
  const s = this.proxy, r = _e(e) ? e.includes(".") ? vi(s, e) : () => s[e] : e.bind(s, s);
  let o;
  G(t) ? o = t : (o = t.handler, n = t);
  const i = Cn(this), l = ar(r, o.bind(s), n);
  return i(), l;
}
function vi(e, t) {
  const n = t.split(".");
  return () => {
    let s = e;
    for (let r = 0; r < n.length && s; r++)
      s = s[n[r]];
    return s;
  };
}
const Tc = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Ge(t)}Modifiers`] || e[`${Ue(t)}Modifiers`];
function Mc(e, t, ...n) {
  if (e.isUnmounted) return;
  const s = e.vnode.props || ue;
  let r = n;
  const o = t.startsWith("update:"), i = o && Tc(s, t.slice(7));
  i && (i.trim && (r = n.map((a) => _e(a) ? a.trim() : a)), i.number && (r = n.map(Ss)));
  let l, c = s[l = as(t)] || // also try camelCase event handler (#2249)
  s[l = as(Ge(t))];
  !c && o && (c = s[l = as(Ue(t))]), c && Qe(
    c,
    e,
    6,
    r
  );
  const u = s[l + "Once"];
  if (u) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[l])
      return;
    e.emitted[l] = !0, Qe(
      u,
      e,
      6,
      r
    );
  }
}
function yi(e, t, n = !1) {
  const s = t.emitsCache, r = s.get(e);
  if (r !== void 0)
    return r;
  const o = e.emits;
  let i = {}, l = !1;
  if (!G(e)) {
    const c = (u) => {
      const a = yi(u, t, !0);
      a && (l = !0, ve(i, a));
    };
    !n && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  return !o && !l ? (he(e) && s.set(e, null), null) : (j(o) ? o.forEach((c) => i[c] = null) : ve(i, o), he(e) && s.set(e, i), i);
}
function os(e, t) {
  return !e || !Gn(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), re(e, t[0].toLowerCase() + t.slice(1)) || re(e, Ue(t)) || re(e, t));
}
function Lr(e) {
  const {
    type: t,
    vnode: n,
    proxy: s,
    withProxy: r,
    propsOptions: [o],
    slots: i,
    attrs: l,
    emit: c,
    render: u,
    renderCache: a,
    props: d,
    data: p,
    setupState: g,
    ctx: v,
    inheritAttrs: _
  } = e, A = Kn(e);
  let L, N;
  try {
    if (n.shapeFlag & 4) {
      const T = r || s, H = T;
      L = ot(
        u.call(
          H,
          T,
          a,
          d,
          g,
          p,
          v
        )
      ), N = l;
    } else {
      const T = t;
      L = ot(
        T.length > 1 ? T(
          d,
          { attrs: l, slots: i, emit: c }
        ) : T(
          d,
          null
        )
      ), N = t.props ? l : Ac(l);
    }
  } catch (T) {
    hn.length = 0, ts(T, e, 1), L = le(Ne);
  }
  let F = L;
  if (N && _ !== !1) {
    const T = Object.keys(N), { shapeFlag: H } = F;
    T.length && H & 7 && (o && T.some(qs) && (N = kc(
      N,
      o
    )), F = Ct(F, N, !1, !0));
  }
  return n.dirs && (F = Ct(F, null, !1, !0), F.dirs = F.dirs ? F.dirs.concat(n.dirs) : n.dirs), n.transition && _n(F, n.transition), L = F, Kn(A), L;
}
const Ac = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || Gn(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, kc = (e, t) => {
  const n = {};
  for (const s in e)
    (!qs(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
  return n;
};
function Ic(e, t, n) {
  const { props: s, children: r, component: o } = e, { props: i, children: l, patchFlag: c } = t, u = o.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && c >= 0) {
    if (c & 1024)
      return !0;
    if (c & 16)
      return s ? Rr(s, i, u) : !!i;
    if (c & 8) {
      const a = t.dynamicProps;
      for (let d = 0; d < a.length; d++) {
        const p = a[d];
        if (i[p] !== s[p] && !os(u, p))
          return !0;
      }
    }
  } else
    return (r || l) && (!l || !l.$stable) ? !0 : s === i ? !1 : s ? i ? Rr(s, i, u) : !0 : !!i;
  return !1;
}
function Rr(e, t, n) {
  const s = Object.keys(t);
  if (s.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < s.length; r++) {
    const o = s[r];
    if (t[o] !== e[o] && !os(n, o))
      return !0;
  }
  return !1;
}
function Oc({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const s = t.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const bi = (e) => e.__isSuspense;
function Lc(e, t) {
  t && t.pendingBranch ? j(e) ? t.effects.push(...e) : t.effects.push(e) : Kl(e);
}
const be = Symbol.for("v-fgt"), is = Symbol.for("v-txt"), Ne = Symbol.for("v-cmt"), Nn = Symbol.for("v-stc"), hn = [];
let Ke = null;
function X(e = !1) {
  hn.push(Ke = e ? null : []);
}
function Rc() {
  hn.pop(), Ke = hn[hn.length - 1] || null;
}
let vn = 1;
function $r(e, t = !1) {
  vn += e, e < 0 && Ke && t && (Ke.hasOnce = !0);
}
function wi(e) {
  return e.dynamicChildren = vn > 0 ? Ke || zt : null, Rc(), vn > 0 && Ke && Ke.push(e), e;
}
function ce(e, t, n, s, r, o) {
  return wi(
    R(
      e,
      t,
      n,
      s,
      r,
      o,
      !0
    )
  );
}
function He(e, t, n, s, r) {
  return wi(
    le(
      e,
      t,
      n,
      s,
      r,
      !0
    )
  );
}
function yn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Nt(e, t) {
  return e.type === t.type && e.key === t.key;
}
const xi = ({ key: e }) => e != null ? e : null, Fn = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? _e(e) || Ce(e) || G(e) ? { i: Se, r: e, k: t, f: !!n } : e : null);
function R(e, t = null, n = null, s = 0, r = null, o = e === be ? 0 : 1, i = !1, l = !1) {
  const c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && xi(t),
    ref: t && Fn(t),
    scopeId: Wo,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: s,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: Se
  };
  return l ? (ur(c, n), o & 128 && e.normalize(c)) : n && (c.shapeFlag |= _e(n) ? 8 : 16), vn > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  Ke && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (c.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  c.patchFlag !== 32 && Ke.push(c), c;
}
const le = $c;
function $c(e, t = null, n = null, s = 0, r = null, o = !1) {
  if ((!e || e === rc) && (e = Ne), yn(e)) {
    const l = Ct(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && ur(l, n), vn > 0 && !o && Ke && (l.shapeFlag & 6 ? Ke[Ke.indexOf(e)] = l : Ke.push(l)), l.patchFlag = -2, l;
  }
  if (qc(e) && (e = e.__vccOpts), t) {
    t = Nc(t);
    let { class: l, style: c } = t;
    l && !_e(l) && (t.class = Zn(l)), he(c) && (nr(c) && !j(c) && (c = ve({}, c)), t.style = Js(c));
  }
  const i = _e(e) ? 1 : bi(e) ? 128 : zo(e) ? 64 : he(e) ? 4 : G(e) ? 2 : 0;
  return R(
    e,
    t,
    n,
    s,
    r,
    i,
    o,
    !0
  );
}
function Nc(e) {
  return e ? nr(e) || ui(e) ? ve({}, e) : e : null;
}
function Ct(e, t, n = !1, s = !1) {
  const { props: r, ref: o, patchFlag: i, children: l, transition: c } = e, u = t ? Pc(r || {}, t) : r, a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && xi(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? j(o) ? o.concat(Fn(t)) : [o, Fn(t)] : Fn(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== be ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: c,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Ct(e.ssContent),
    ssFallback: e.ssFallback && Ct(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return c && s && _n(
    a,
    c.clone(a)
  ), a;
}
function St(e = " ", t = 0) {
  return le(is, null, e, t);
}
function Fc(e, t) {
  const n = le(Nn, null, e);
  return n.staticCount = t, n;
}
function ze(e = "", t = !1) {
  return t ? (X(), He(Ne, null, e)) : le(Ne, null, e);
}
function ot(e) {
  return e == null || typeof e == "boolean" ? le(Ne) : j(e) ? le(
    be,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : yn(e) ? wt(e) : le(is, null, String(e));
}
function wt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Ct(e);
}
function ur(e, t) {
  let n = 0;
  const { shapeFlag: s } = e;
  if (t == null)
    t = null;
  else if (j(t))
    n = 16;
  else if (typeof t == "object")
    if (s & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), ur(e, r()), r._c && (r._d = !0));
      return;
    } else {
      n = 32;
      const r = t._;
      !r && !ui(t) ? t._ctx = Se : r === 3 && Se && (Se.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else G(t) ? (t = { default: t, _ctx: Se }, n = 32) : (t = String(t), s & 64 ? (n = 16, t = [St(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Pc(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    for (const r in s)
      if (r === "class")
        t.class !== s.class && (t.class = Zn([t.class, s.class]));
      else if (r === "style")
        t.style = Js([t.style, s.style]);
      else if (Gn(r)) {
        const o = t[r], i = s[r];
        i && o !== i && !(j(o) && o.includes(i)) && (t[r] = o ? [].concat(o, i) : i);
      } else r !== "" && (t[r] = s[r]);
  }
  return t;
}
function nt(e, t, n, s = null) {
  Qe(e, t, 7, [
    n,
    s
  ]);
}
const Dc = ii();
let jc = 0;
function Hc(e, t, n) {
  const s = e.type, r = (t ? t.appContext : e.appContext) || Dc, o = {
    uid: jc++,
    vnode: e,
    type: s,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new ll(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: di(s, r),
    emitsOptions: yi(s, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: ue,
    // inheritAttrs
    inheritAttrs: s.inheritAttrs,
    // state
    ctx: ue,
    data: ue,
    props: ue,
    attrs: ue,
    slots: ue,
    refs: ue,
    setupState: ue,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = t ? t.root : o, o.emit = Mc.bind(null, o), e.ce && e.ce(o), o;
}
let ke = null;
const Vc = () => ke || Se;
let Wn, Ns;
{
  const e = Xn(), t = (n, s) => {
    let r;
    return (r = e[n]) || (r = e[n] = []), r.push(s), (o) => {
      r.length > 1 ? r.forEach((i) => i(o)) : r[0](o);
    };
  };
  Wn = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => ke = n
  ), Ns = t(
    "__VUE_SSR_SETTERS__",
    (n) => bn = n
  );
}
const Cn = (e) => {
  const t = ke;
  return Wn(e), e.scope.on(), () => {
    e.scope.off(), Wn(t);
  };
}, Nr = () => {
  ke && ke.scope.off(), Wn(null);
};
function Si(e) {
  return e.vnode.shapeFlag & 4;
}
let bn = !1;
function Kc(e, t = !1, n = !1) {
  t && Ns(t);
  const { props: s, children: r } = e.vnode, o = Si(e);
  hc(e, s, o, t), _c(e, r, n);
  const i = o ? Bc(e, t) : void 0;
  return t && Ns(!1), i;
}
function Bc(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, oc);
  const { setup: s } = n;
  if (s) {
    Et();
    const r = e.setupContext = s.length > 1 ? Wc(e) : null, o = Cn(e), i = xn(
      s,
      e,
      0,
      [
        e.props,
        r
      ]
    ), l = _o(i);
    if (Tt(), o(), (l || e.sp) && !Yt(e) && ti(e), l) {
      if (i.then(Nr, Nr), t)
        return i.then((c) => {
          Fr(e, c);
        }).catch((c) => {
          ts(c, e, 0);
        });
      e.asyncDep = i;
    } else
      Fr(e, i);
  } else
    Ci(e);
}
function Fr(e, t, n) {
  G(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : he(t) && (e.setupState = Ho(t)), Ci(e);
}
function Ci(e, t, n) {
  const s = e.type;
  e.render || (e.render = s.render || lt);
  {
    const r = Cn(e);
    Et();
    try {
      ic(e);
    } finally {
      Tt(), r();
    }
  }
}
const Uc = {
  get(e, t) {
    return Me(e, "get", ""), e[t];
  }
};
function Wc(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    attrs: new Proxy(e.attrs, Uc),
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function ls(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Ho(kl(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in dn)
        return dn[n](e);
    },
    has(t, n) {
      return n in t || n in dn;
    }
  })) : e.proxy;
}
function qc(e) {
  return G(e) && "__vccOpts" in e;
}
const we = (e, t) => Pl(e, t, bn);
function en(e, t, n) {
  const s = arguments.length;
  return s === 2 ? he(t) && !j(t) ? yn(t) ? le(e, null, [t]) : le(e, t) : le(e, null, t) : (s > 3 ? n = Array.prototype.slice.call(arguments, 2) : s === 3 && yn(n) && (n = [n]), le(e, t, n));
}
const zc = "3.5.13";
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Fs;
const Pr = typeof window != "undefined" && window.trustedTypes;
if (Pr)
  try {
    Fs = /* @__PURE__ */ Pr.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
  }
const Ei = Fs ? (e) => Fs.createHTML(e) : (e) => e, Gc = "http://www.w3.org/2000/svg", Jc = "http://www.w3.org/1998/Math/MathML", ft = typeof document != "undefined" ? document : null, Dr = ft && /* @__PURE__ */ ft.createElement("template"), Qc = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, s) => {
    const r = t === "svg" ? ft.createElementNS(Gc, e) : t === "mathml" ? ft.createElementNS(Jc, e) : n ? ft.createElement(e, { is: n }) : ft.createElement(e);
    return e === "select" && s && s.multiple != null && r.setAttribute("multiple", s.multiple), r;
  },
  createText: (e) => ft.createTextNode(e),
  createComment: (e) => ft.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => ft.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, s, r, o) {
    const i = n ? n.previousSibling : t.lastChild;
    if (r && (r === o || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), n), !(r === o || !(r = r.nextSibling)); )
        ;
    else {
      Dr.innerHTML = Ei(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const l = Dr.content;
      if (s === "svg" || s === "mathml") {
        const c = l.firstChild;
        for (; c.firstChild; )
          l.appendChild(c.firstChild);
        l.removeChild(c);
      }
      t.insertBefore(l, n);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, _t = "transition", rn = "animation", wn = Symbol("_vtc"), Ti = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, Yc = /* @__PURE__ */ ve(
  {},
  Qo,
  Ti
), Xc = (e) => (e.displayName = "Transition", e.props = Yc, e), Zc = /* @__PURE__ */ Xc(
  (e, { slots: t }) => en(zl, ea(e), t)
), Lt = (e, t = []) => {
  j(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, jr = (e) => e ? j(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function ea(e) {
  const t = {};
  for (const E in e)
    E in Ti || (t[E] = e[E]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: s,
    duration: r,
    enterFromClass: o = `${n}-enter-from`,
    enterActiveClass: i = `${n}-enter-active`,
    enterToClass: l = `${n}-enter-to`,
    appearFromClass: c = o,
    appearActiveClass: u = i,
    appearToClass: a = l,
    leaveFromClass: d = `${n}-leave-from`,
    leaveActiveClass: p = `${n}-leave-active`,
    leaveToClass: g = `${n}-leave-to`
  } = e, v = ta(r), _ = v && v[0], A = v && v[1], {
    onBeforeEnter: L,
    onEnter: N,
    onEnterCancelled: F,
    onLeave: T,
    onLeaveCancelled: H,
    onBeforeAppear: J = L,
    onAppear: Q = N,
    onAppearCancelled: U = F
  } = t, O = (E, B, ae, $) => {
    E._enterCancelled = $, Rt(E, B ? a : l), Rt(E, B ? u : i), ae && ae();
  }, W = (E, B) => {
    E._isLeaving = !1, Rt(E, d), Rt(E, g), Rt(E, p), B && B();
  }, Z = (E) => (B, ae) => {
    const $ = E ? Q : N, K = () => O(B, E, ae);
    Lt($, [B, K]), Hr(() => {
      Rt(B, E ? c : o), ut(B, E ? a : l), jr($) || Vr(B, s, _, K);
    });
  };
  return ve(t, {
    onBeforeEnter(E) {
      Lt(L, [E]), ut(E, o), ut(E, i);
    },
    onBeforeAppear(E) {
      Lt(J, [E]), ut(E, c), ut(E, u);
    },
    onEnter: Z(!1),
    onAppear: Z(!0),
    onLeave(E, B) {
      E._isLeaving = !0;
      const ae = () => W(E, B);
      ut(E, d), E._enterCancelled ? (ut(E, p), Ur()) : (Ur(), ut(E, p)), Hr(() => {
        E._isLeaving && (Rt(E, d), ut(E, g), jr(T) || Vr(E, s, A, ae));
      }), Lt(T, [E, ae]);
    },
    onEnterCancelled(E) {
      O(E, !1, void 0, !0), Lt(F, [E]);
    },
    onAppearCancelled(E) {
      O(E, !0, void 0, !0), Lt(U, [E]);
    },
    onLeaveCancelled(E) {
      W(E), Lt(H, [E]);
    }
  });
}
function ta(e) {
  if (e == null)
    return null;
  if (he(e))
    return [_s(e.enter), _s(e.leave)];
  {
    const t = _s(e);
    return [t, t];
  }
}
function _s(e) {
  return Cs(e);
}
function ut(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[wn] || (e[wn] = /* @__PURE__ */ new Set())).add(t);
}
function Rt(e, t) {
  t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
  const n = e[wn];
  n && (n.delete(t), n.size || (e[wn] = void 0));
}
function Hr(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let na = 0;
function Vr(e, t, n, s) {
  const r = e._endId = ++na, o = () => {
    r === e._endId && s();
  };
  if (n != null)
    return setTimeout(o, n);
  const { type: i, timeout: l, propCount: c } = sa(e, t);
  if (!i)
    return s();
  const u = i + "end";
  let a = 0;
  const d = () => {
    e.removeEventListener(u, p), o();
  }, p = (g) => {
    g.target === e && ++a >= c && d();
  };
  setTimeout(() => {
    a < c && d();
  }, l + 1), e.addEventListener(u, p);
}
function sa(e, t) {
  const n = window.getComputedStyle(e), s = (v) => (n[v] || "").split(", "), r = s(`${_t}Delay`), o = s(`${_t}Duration`), i = Kr(r, o), l = s(`${rn}Delay`), c = s(`${rn}Duration`), u = Kr(l, c);
  let a = null, d = 0, p = 0;
  t === _t ? i > 0 && (a = _t, d = i, p = o.length) : t === rn ? u > 0 && (a = rn, d = u, p = c.length) : (d = Math.max(i, u), a = d > 0 ? i > u ? _t : rn : null, p = a ? a === _t ? o.length : c.length : 0);
  const g = a === _t && /\b(transform|all)(,|$)/.test(
    s(`${_t}Property`).toString()
  );
  return {
    type: a,
    timeout: d,
    propCount: p,
    hasTransform: g
  };
}
function Kr(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, s) => Br(n) + Br(e[s])));
}
function Br(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function Ur() {
  return document.body.offsetHeight;
}
function ra(e, t, n) {
  const s = e[wn];
  s && (t = (t ? [t, ...s] : [...s]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const qn = Symbol("_vod"), Mi = Symbol("_vsh"), Ai = {
  beforeMount(e, { value: t }, { transition: n }) {
    e[qn] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : on(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: s }) {
    !t != !n && (s ? t ? (s.beforeEnter(e), on(e, !0), s.enter(e)) : s.leave(e, () => {
      on(e, !1);
    }) : on(e, t));
  },
  beforeUnmount(e, { value: t }) {
    on(e, t);
  }
};
function on(e, t) {
  e.style.display = t ? e[qn] : "none", e[Mi] = !t;
}
const oa = Symbol(""), ia = /(^|;)\s*display\s*:/;
function la(e, t, n) {
  const s = e.style, r = _e(n);
  let o = !1;
  if (n && !r) {
    if (t)
      if (_e(t))
        for (const i of t.split(";")) {
          const l = i.slice(0, i.indexOf(":")).trim();
          n[l] == null && Pn(s, l, "");
        }
      else
        for (const i in t)
          n[i] == null && Pn(s, i, "");
    for (const i in n)
      i === "display" && (o = !0), Pn(s, i, n[i]);
  } else if (r) {
    if (t !== n) {
      const i = s[oa];
      i && (n += ";" + i), s.cssText = n, o = ia.test(n);
    }
  } else t && e.removeAttribute("style");
  qn in e && (e[qn] = o ? s.display : "", e[Mi] && (s.display = "none"));
}
const Wr = /\s*!important$/;
function Pn(e, t, n) {
  if (j(n))
    n.forEach((s) => Pn(e, t, s));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const s = ca(e, t);
    Wr.test(n) ? e.setProperty(
      Ue(s),
      n.replace(Wr, ""),
      "important"
    ) : e[s] = n;
  }
}
const qr = ["Webkit", "Moz", "ms"], vs = {};
function ca(e, t) {
  const n = vs[t];
  if (n)
    return n;
  let s = Ge(t);
  if (s !== "filter" && s in e)
    return vs[t] = s;
  s = yo(s);
  for (let r = 0; r < qr.length; r++) {
    const o = qr[r] + s;
    if (o in e)
      return vs[t] = o;
  }
  return t;
}
const zr = "http://www.w3.org/1999/xlink";
function Gr(e, t, n, s, r, o = il(t)) {
  s && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(zr, t.slice(6, t.length)) : e.setAttributeNS(zr, t, n) : n == null || o && !wo(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    o ? "" : mt(n) ? String(n) : n
  );
}
function Jr(e, t, n, s, r) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? Ei(n) : n);
    return;
  }
  const o = e.tagName;
  if (t === "value" && o !== "PROGRESS" && // custom elements may use _value internally
  !o.includes("-")) {
    const l = o === "OPTION" ? e.getAttribute("value") || "" : e.value, c = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (l !== c || !("_value" in e)) && (e.value = c), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let i = !1;
  if (n === "" || n == null) {
    const l = typeof e[t];
    l === "boolean" ? n = wo(n) : n == null && l === "string" ? (n = "", i = !0) : l === "number" && (n = 0, i = !0);
  }
  try {
    e[t] = n;
  } catch (l) {
  }
  i && e.removeAttribute(r || t);
}
function qt(e, t, n, s) {
  e.addEventListener(t, n, s);
}
function aa(e, t, n, s) {
  e.removeEventListener(t, n, s);
}
const Qr = Symbol("_vei");
function ua(e, t, n, s, r = null) {
  const o = e[Qr] || (e[Qr] = {}), i = o[t];
  if (s && i)
    i.value = s;
  else {
    const [l, c] = fa(t);
    if (s) {
      const u = o[t] = pa(
        s,
        r
      );
      qt(e, l, u, c);
    } else i && (aa(e, l, i, c), o[t] = void 0);
  }
}
const Yr = /(?:Once|Passive|Capture)$/;
function fa(e) {
  let t;
  if (Yr.test(e)) {
    t = {};
    let s;
    for (; s = e.match(Yr); )
      e = e.slice(0, e.length - s[0].length), t[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Ue(e.slice(2)), t];
}
let ys = 0;
const da = /* @__PURE__ */ Promise.resolve(), ha = () => ys || (da.then(() => ys = 0), ys = Date.now());
function pa(e, t) {
  const n = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= n.attached)
      return;
    Qe(
      ma(s, n.value),
      t,
      5,
      [s]
    );
  };
  return n.value = e, n.attached = ha(), n;
}
function ma(e, t) {
  if (j(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (s) => (r) => !r._stopped && s && s(r)
    );
  } else
    return t;
}
const Xr = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, ga = (e, t, n, s, r, o) => {
  const i = r === "svg";
  t === "class" ? ra(e, s, i) : t === "style" ? la(e, n, s) : Gn(t) ? qs(t) || ua(e, t, n, s, o) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : _a(e, t, s, i)) ? (Jr(e, t, s), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Gr(e, t, s, i, o, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !_e(s)) ? Jr(e, Ge(t), s, o, t) : (t === "true-value" ? e._trueValue = s : t === "false-value" && (e._falseValue = s), Gr(e, t, s, i));
};
function _a(e, t, n, s) {
  if (s)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Xr(t) && G(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return Xr(t) && _e(n) ? !1 : t in e;
}
const Zr = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function va(e, t, n) {
  const s = /* @__PURE__ */ xe(e, t);
  Qn(s) && ve(s, t);
  class r extends fr {
    constructor(i) {
      super(s, i, n);
    }
  }
  return r.def = s, r;
}
const ya = typeof HTMLElement != "undefined" ? HTMLElement : class {
};
class fr extends ya {
  constructor(t, n = {}, s = so) {
    super(), this._def = t, this._props = n, this._createApp = s, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && s !== so ? this._root = this.shadowRoot : t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this, this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof fr) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, Pt(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let s = 0; s < this.attributes.length; s++)
      this._setAttr(this.attributes[s].name);
    this._ob = new MutationObserver((s) => {
      for (const r of s)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (s, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: o, styles: i } = s;
      let l;
      if (o && !j(o))
        for (const c in o) {
          const u = o[c];
          (u === Number || u && u.type === Number) && (c in this._props && (this._props[c] = Cs(this._props[c])), (l || (l = /* @__PURE__ */ Object.create(null)))[Ge(c)] = !0);
        }
      this._numberProps = l, r && this._resolveProps(s), this.shadowRoot && this._applyStyles(i), this._mount(s);
    }, n = this._def.__asyncLoader;
    n ? this._pendingResolve = n().then(
      (s) => t(this._def = s, !0)
    ) : t(this._def);
  }
  _mount(t) {
    this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const n = this._instance && this._instance.exposed;
    if (n)
      for (const s in n)
        re(this, s) || Object.defineProperty(this, s, {
          // unwrap ref to be consistent with public instance behavior
          get: () => me(n[s])
        });
  }
  _resolveProps(t) {
    const { props: n } = t, s = j(n) ? n : Object.keys(n || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && s.includes(r) && this._setProp(r, this[r]);
    for (const r of s.map(Ge))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(o) {
          this._setProp(r, o, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const n = this.hasAttribute(t);
    let s = n ? this.getAttribute(t) : Zr;
    const r = Ge(t);
    n && this._numberProps && this._numberProps[r] && (s = Cs(s)), this._setProp(r, s, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, s = !0, r = !1) {
    if (n !== this._props[t] && (n === Zr ? delete this._props[t] : (this._props[t] = n, t === "key" && this._app && (this._app._ceVNode.key = n)), r && this._instance && this._update(), s)) {
      const o = this._ob;
      o && o.disconnect(), n === !0 ? this.setAttribute(Ue(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(Ue(t), n + "") : n || this.removeAttribute(Ue(t)), o && o.observe(this, { attributes: !0 });
    }
  }
  _update() {
    Ta(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const n = le(this._def, ve(t, this._props));
    return this._instance || (n.ce = (s) => {
      this._instance = s, s.ce = this, s.isCE = !0;
      const r = (o, i) => {
        this.dispatchEvent(
          new CustomEvent(
            o,
            Qn(i[0]) ? ve({ detail: i }, i[0]) : { detail: i }
          )
        );
      };
      s.emit = (o, ...i) => {
        r(o, i), Ue(o) !== o && r(Ue(o), i);
      }, this._setParent();
    }), n;
  }
  _applyStyles(t, n) {
    if (!t) return;
    if (n) {
      if (n === this._def || this._styleChildren.has(n))
        return;
      this._styleChildren.add(n);
    }
    const s = this._nonce;
    for (let r = t.length - 1; r >= 0; r--) {
      const o = document.createElement("style");
      s && o.setAttribute("nonce", s), o.textContent = t[r], this.shadowRoot.prepend(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let n;
    for (; n = this.firstChild; ) {
      const s = n.nodeType === 1 && n.getAttribute("slot") || "default";
      (t[s] || (t[s] = [])).push(n), this.removeChild(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), n = this._instance.type.__scopeId;
    for (let s = 0; s < t.length; s++) {
      const r = t[s], o = r.getAttribute("name") || "default", i = this._slots[o], l = r.parentNode;
      if (i)
        for (const c of i) {
          if (n && c.nodeType === 1) {
            const u = n + "-s", a = document.createTreeWalker(c, 1);
            c.setAttribute(u, "");
            let d;
            for (; d = a.nextNode(); )
              d.setAttribute(u, "");
          }
          l.insertBefore(c, r);
        }
      else
        for (; r.firstChild; ) l.insertBefore(r.firstChild, r);
      l.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
  }
}
const eo = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return j(t) ? (n) => Ln(t, n) : t;
};
function ba(e) {
  e.target.composing = !0;
}
function to(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const bs = Symbol("_assign"), wa = {
  created(e, { modifiers: { lazy: t, trim: n, number: s } }, r) {
    e[bs] = eo(r);
    const o = s || r.props && r.props.type === "number";
    qt(e, t ? "change" : "input", (i) => {
      if (i.target.composing) return;
      let l = e.value;
      n && (l = l.trim()), o && (l = Ss(l)), e[bs](l);
    }), n && qt(e, "change", () => {
      e.value = e.value.trim();
    }), t || (qt(e, "compositionstart", ba), qt(e, "compositionend", to), qt(e, "change", to));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t == null ? "" : t;
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: r, number: o } }, i) {
    if (e[bs] = eo(i), e.composing) return;
    const l = (o || e.type === "number") && !/^0\d/.test(e.value) ? Ss(e.value) : e.value, c = t == null ? "" : t;
    l !== c && (document.activeElement === e && e.type !== "range" && (s && t === n || r && e.value.trim() === c) || (e.value = c));
  }
}, xa = ["ctrl", "shift", "alt", "meta"], Sa = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => xa.some((n) => e[`${n}Key`] && !t.includes(n))
}, Ca = (e, t) => {
  const n = e._withMods || (e._withMods = {}), s = t.join(".");
  return n[s] || (n[s] = (r, ...o) => {
    for (let i = 0; i < t.length; i++) {
      const l = Sa[t[i]];
      if (l && l(r, t)) return;
    }
    return e(r, ...o);
  });
}, Ea = /* @__PURE__ */ ve({ patchProp: ga }, Qc);
let no;
function ki() {
  return no || (no = yc(Ea));
}
const Ta = (...e) => {
  ki().render(...e);
}, so = (...e) => {
  const t = ki().createApp(...e), { mount: n } = t;
  return t.mount = (s) => {
    const r = Aa(s);
    if (!r) return;
    const o = t._component;
    !G(o) && !o.render && !o.template && (o.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const i = n(r, !1, Ma(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), i;
  }, t;
};
function Ma(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function Aa(e) {
  return _e(e) ? document.querySelector(e) : e;
}
var ro;
const Ii = typeof window < "u", ka = (e) => typeof e == "string", Dn = () => {
};
Ii && (ro = window == null ? void 0 : window.navigator) != null && ro.userAgent && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Ps(e) {
  return typeof e == "function" ? e() : me(e);
}
function Ia(e, t) {
  function n(...s) {
    e(() => t.apply(this, s), { fn: t, thisArg: this, args: s });
  }
  return n;
}
function Oa(e, t = {}) {
  let n, s;
  return (r) => {
    const o = Ps(e), i = Ps(t.maxWait);
    if (n && clearTimeout(n), o <= 0 || i !== void 0 && i <= 0)
      return s && (clearTimeout(s), s = null), r();
    i && !s && (s = setTimeout(() => {
      n && clearTimeout(n), s = null, r();
    }, i)), n = setTimeout(() => {
      s && clearTimeout(s), s = null, r();
    }, o);
  };
}
function La(e) {
  return e;
}
function Ra(e) {
  return Co() ? (cl(e), !0) : !1;
}
function $a(e, t = 200, n = {}) {
  return Ia(Oa(t, n), e);
}
function ws(e, t = 200, n = {}) {
  if (t <= 0)
    return e;
  const s = ge(e.value), r = $a(() => {
    s.value = e.value;
  }, t, n);
  return We(e, () => r()), s;
}
function Oi(e, t, n) {
  return We(e, (s, r, o) => {
    s && t(s, r, o);
  }, n);
}
function Na(e) {
  var t;
  const n = Ps(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Li = Ii ? window : void 0;
function In(...e) {
  let t, n, s, r;
  if (ka(e[0]) ? ([n, s, r] = e, t = Li) : [t, n, s, r] = e, !t)
    return Dn;
  let o = Dn;
  const i = We(() => Na(t), (c) => {
    o(), c && (c.addEventListener(n, s, r), o = () => {
      c.removeEventListener(n, s, r), o = Dn;
    });
  }, { immediate: !0, flush: "post" }), l = () => {
    i(), o();
  };
  return Ra(l), l;
}
const oo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, io = "__vueuse_ssr_handlers__";
oo[io] = oo[io] || {};
const Fa = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function Pa(e = {}) {
  const {
    reactive: t = !1,
    target: n = Li,
    aliasMap: s = Fa,
    passive: r = !0,
    onEventFired: o = Dn
  } = e, i = Zt(/* @__PURE__ */ new Set()), l = { toJSON() {
    return {};
  }, current: i }, c = t ? Zt(l) : l, u = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  function d(_, A) {
    _ in c && (t ? c[_] = A : c[_].value = A);
  }
  function p() {
    for (const _ of a)
      d(_, !1);
  }
  function g(_, A) {
    var L, N;
    const F = (L = _.key) == null ? void 0 : L.toLowerCase(), T = [(N = _.code) == null ? void 0 : N.toLowerCase(), F].filter(Boolean);
    F && (A ? i.add(F) : i.delete(F));
    for (const H of T)
      a.add(H), d(H, A);
    F === "meta" && !A ? (u.forEach((H) => {
      i.delete(H), d(H, !1);
    }), u.clear()) : typeof _.getModifierState == "function" && _.getModifierState("Meta") && A && [...i, ...T].forEach((H) => u.add(H));
  }
  In(n, "keydown", (_) => (g(_, !0), o(_)), { passive: r }), In(n, "keyup", (_) => (g(_, !1), o(_)), { passive: r }), In("blur", p, { passive: !0 }), In("focus", p, { passive: !0 });
  const v = new Proxy(c, {
    get(_, A, L) {
      if (typeof A != "string")
        return Reflect.get(_, A, L);
      if (A = A.toLowerCase(), A in s && (A = s[A]), !(A in c))
        if (/[+_-]/.test(A)) {
          const F = A.split(/[+_-]/g).map((T) => T.trim());
          c[A] = we(() => F.every((T) => me(v[T])));
        } else
          c[A] = ge(!1);
      const N = Reflect.get(_, A, L);
      return t ? me(N) : N;
    }
  });
  return v;
}
var lo;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(lo || (lo = {}));
var Da = Object.defineProperty, co = Object.getOwnPropertySymbols, ja = Object.prototype.hasOwnProperty, Ha = Object.prototype.propertyIsEnumerable, ao = (e, t, n) => t in e ? Da(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Va = (e, t) => {
  for (var n in t || (t = {}))
    ja.call(t, n) && ao(e, n, t[n]);
  if (co)
    for (var n of co(t))
      Ha.call(t, n) && ao(e, n, t[n]);
  return e;
};
const Ka = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Va({
  linear: La
}, Ka);
function pt(e) {
  return Array.isArray ? Array.isArray(e) : Ni(e) === "[object Array]";
}
function Ba(e) {
  if (typeof e == "string")
    return e;
  let t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Ua(e) {
  return e == null ? "" : Ba(e);
}
function it(e) {
  return typeof e == "string";
}
function Ri(e) {
  return typeof e == "number";
}
function Wa(e) {
  return e === !0 || e === !1 || qa(e) && Ni(e) == "[object Boolean]";
}
function $i(e) {
  return typeof e == "object";
}
function qa(e) {
  return $i(e) && e !== null;
}
function Ve(e) {
  return e != null;
}
function xs(e) {
  return !e.trim().length;
}
function Ni(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
const za = "Incorrect 'index' type", Ga = (e) => `Invalid value for key ${e}`, Ja = (e) => `Pattern length exceeds max of ${e}.`, Qa = (e) => `Missing ${e} property in key`, Ya = (e) => `Property 'weight' in key '${e}' must be a positive integer`, uo = Object.prototype.hasOwnProperty;
class Xa {
  constructor(t) {
    this._keys = [], this._keyMap = {};
    let n = 0;
    t.forEach((s) => {
      let r = Fi(s);
      n += r.weight, this._keys.push(r), this._keyMap[r.id] = r, n += r.weight;
    }), this._keys.forEach((s) => {
      s.weight /= n;
    });
  }
  get(t) {
    return this._keyMap[t];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function Fi(e) {
  let t = null, n = null, s = null, r = 1, o = null;
  if (it(e) || pt(e))
    s = e, t = fo(e), n = Ds(e);
  else {
    if (!uo.call(e, "name"))
      throw new Error(Qa("name"));
    const i = e.name;
    if (s = i, uo.call(e, "weight") && (r = e.weight, r <= 0))
      throw new Error(Ya(i));
    t = fo(i), n = Ds(i), o = e.getFn;
  }
  return { path: t, id: n, weight: r, src: s, getFn: o };
}
function fo(e) {
  return pt(e) ? e : e.split(".");
}
function Ds(e) {
  return pt(e) ? e.join(".") : e;
}
function Za(e, t) {
  let n = [], s = !1;
  const r = (o, i, l) => {
    if (Ve(o))
      if (!i[l])
        n.push(o);
      else {
        let c = i[l];
        const u = o[c];
        if (!Ve(u))
          return;
        if (l === i.length - 1 && (it(u) || Ri(u) || Wa(u)))
          n.push(Ua(u));
        else if (pt(u)) {
          s = !0;
          for (let a = 0, d = u.length; a < d; a += 1)
            r(u[a], i, l + 1);
        } else
          i.length && r(u, i, l + 1);
      }
  };
  return r(e, it(t) ? t.split(".") : t, 0), s ? n : n[0];
}
const eu = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, tu = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (e, t) => e.score === t.score ? e.idx < t.idx ? -1 : 1 : e.score < t.score ? -1 : 1
}, nu = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, su = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: Za,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var z = ye(ye(ye(ye({}, tu), eu), nu), su);
const ru = /[^ ]+/g;
function ou(e = 1, t = 3) {
  const n = /* @__PURE__ */ new Map(), s = Math.pow(10, t);
  return {
    get(r) {
      const o = r.match(ru).length;
      if (n.has(o))
        return n.get(o);
      const i = 1 / Math.pow(o, 0.5 * e), l = parseFloat(Math.round(i * s) / s);
      return n.set(o, l), l;
    },
    clear() {
      n.clear();
    }
  };
}
class dr {
  constructor({
    getFn: t = z.getFn,
    fieldNormWeight: n = z.fieldNormWeight
  } = {}) {
    this.norm = ou(n, 3), this.getFn = t, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(t = []) {
    this.docs = t;
  }
  setIndexRecords(t = []) {
    this.records = t;
  }
  setKeys(t = []) {
    this.keys = t, this._keysMap = {}, t.forEach((n, s) => {
      this._keysMap[n.id] = s;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, it(this.docs[0]) ? this.docs.forEach((t, n) => {
      this._addString(t, n);
    }) : this.docs.forEach((t, n) => {
      this._addObject(t, n);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(t) {
    const n = this.size();
    it(t) ? this._addString(t, n) : this._addObject(t, n);
  }
  // Removes the doc at the specified index of the index
  removeAt(t) {
    this.records.splice(t, 1);
    for (let n = t, s = this.size(); n < s; n += 1)
      this.records[n].i -= 1;
  }
  getValueForItemAtKeyId(t, n) {
    return t[this._keysMap[n]];
  }
  size() {
    return this.records.length;
  }
  _addString(t, n) {
    if (!Ve(t) || xs(t))
      return;
    let s = {
      v: t,
      i: n,
      n: this.norm.get(t)
    };
    this.records.push(s);
  }
  _addObject(t, n) {
    let s = { i: n, $: {} };
    this.keys.forEach((r, o) => {
      let i = r.getFn ? r.getFn(t) : this.getFn(t, r.path);
      if (Ve(i)) {
        if (pt(i)) {
          let l = [];
          const c = [{ nestedArrIndex: -1, value: i }];
          for (; c.length; ) {
            const { nestedArrIndex: u, value: a } = c.pop();
            if (Ve(a))
              if (it(a) && !xs(a)) {
                let d = {
                  v: a,
                  i: u,
                  n: this.norm.get(a)
                };
                l.push(d);
              } else
                pt(a) && a.forEach((d, p) => {
                  c.push({
                    nestedArrIndex: p,
                    value: d
                  });
                });
          }
          s.$[o] = l;
        } else if (it(i) && !xs(i)) {
          let l = {
            v: i,
            n: this.norm.get(i)
          };
          s.$[o] = l;
        }
      }
    }), this.records.push(s);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function Pi(e, t, { getFn: n = z.getFn, fieldNormWeight: s = z.fieldNormWeight } = {}) {
  const r = new dr({ getFn: n, fieldNormWeight: s });
  return r.setKeys(e.map(Fi)), r.setSources(t), r.create(), r;
}
function iu(e, { getFn: t = z.getFn, fieldNormWeight: n = z.fieldNormWeight } = {}) {
  const { keys: s, records: r } = e, o = new dr({ getFn: t, fieldNormWeight: n });
  return o.setKeys(s), o.setIndexRecords(r), o;
}
function On(e, {
  errors: t = 0,
  currentLocation: n = 0,
  expectedLocation: s = 0,
  distance: r = z.distance,
  ignoreLocation: o = z.ignoreLocation
} = {}) {
  const i = t / e.length;
  if (o)
    return i;
  const l = Math.abs(s - n);
  return r ? i + l / r : l ? 1 : i;
}
function lu(e = [], t = z.minMatchCharLength) {
  let n = [], s = -1, r = -1, o = 0;
  for (let i = e.length; o < i; o += 1) {
    let l = e[o];
    l && s === -1 ? s = o : !l && s !== -1 && (r = o - 1, r - s + 1 >= t && n.push([s, r]), s = -1);
  }
  return e[o - 1] && o - s >= t && n.push([s, o - 1]), n;
}
const Ft = 32;
function cu(e, t, n, {
  location: s = z.location,
  distance: r = z.distance,
  threshold: o = z.threshold,
  findAllMatches: i = z.findAllMatches,
  minMatchCharLength: l = z.minMatchCharLength,
  includeMatches: c = z.includeMatches,
  ignoreLocation: u = z.ignoreLocation
} = {}) {
  if (t.length > Ft)
    throw new Error(Ja(Ft));
  const a = t.length, d = e.length, p = Math.max(0, Math.min(s, d));
  let g = o, v = p;
  const _ = l > 1 || c, A = _ ? Array(d) : [];
  let L;
  for (; (L = e.indexOf(t, v)) > -1; ) {
    let Q = On(t, {
      currentLocation: L,
      expectedLocation: p,
      distance: r,
      ignoreLocation: u
    });
    if (g = Math.min(Q, g), v = L + a, _) {
      let U = 0;
      for (; U < a; )
        A[L + U] = 1, U += 1;
    }
  }
  v = -1;
  let N = [], F = 1, T = a + d;
  const H = 1 << a - 1;
  for (let Q = 0; Q < a; Q += 1) {
    let U = 0, O = T;
    for (; U < O; )
      On(t, {
        errors: Q,
        currentLocation: p + O,
        expectedLocation: p,
        distance: r,
        ignoreLocation: u
      }) <= g ? U = O : T = O, O = Math.floor((T - U) / 2 + U);
    T = O;
    let W = Math.max(1, p - O + 1), Z = i ? d : Math.min(p + O, d) + a, E = Array(Z + 2);
    E[Z + 1] = (1 << Q) - 1;
    for (let B = Z; B >= W; B -= 1) {
      let ae = B - 1, $ = n[e.charAt(ae)];
      if (_ && (A[ae] = +!!$), E[B] = (E[B + 1] << 1 | 1) & $, Q && (E[B] |= (N[B + 1] | N[B]) << 1 | 1 | N[B + 1]), E[B] & H && (F = On(t, {
        errors: Q,
        currentLocation: ae,
        expectedLocation: p,
        distance: r,
        ignoreLocation: u
      }), F <= g)) {
        if (g = F, v = ae, v <= p)
          break;
        W = Math.max(1, 2 * p - v);
      }
    }
    if (On(t, {
      errors: Q + 1,
      currentLocation: p,
      expectedLocation: p,
      distance: r,
      ignoreLocation: u
    }) > g)
      break;
    N = E;
  }
  const J = {
    isMatch: v >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, F)
  };
  if (_) {
    const Q = lu(A, l);
    Q.length ? c && (J.indices = Q) : J.isMatch = !1;
  }
  return J;
}
function au(e) {
  let t = {};
  for (let n = 0, s = e.length; n < s; n += 1) {
    const r = e.charAt(n);
    t[r] = (t[r] || 0) | 1 << s - n - 1;
  }
  return t;
}
class Di {
  constructor(t, {
    location: n = z.location,
    threshold: s = z.threshold,
    distance: r = z.distance,
    includeMatches: o = z.includeMatches,
    findAllMatches: i = z.findAllMatches,
    minMatchCharLength: l = z.minMatchCharLength,
    isCaseSensitive: c = z.isCaseSensitive,
    ignoreLocation: u = z.ignoreLocation
  } = {}) {
    if (this.options = {
      location: n,
      threshold: s,
      distance: r,
      includeMatches: o,
      findAllMatches: i,
      minMatchCharLength: l,
      isCaseSensitive: c,
      ignoreLocation: u
    }, this.pattern = c ? t : t.toLowerCase(), this.chunks = [], !this.pattern.length)
      return;
    const a = (p, g) => {
      this.chunks.push({
        pattern: p,
        alphabet: au(p),
        startIndex: g
      });
    }, d = this.pattern.length;
    if (d > Ft) {
      let p = 0;
      const g = d % Ft, v = d - g;
      for (; p < v; )
        a(this.pattern.substr(p, Ft), p), p += Ft;
      if (g) {
        const _ = d - Ft;
        a(this.pattern.substr(_), _);
      }
    } else
      a(this.pattern, 0);
  }
  searchIn(t) {
    const { isCaseSensitive: n, includeMatches: s } = this.options;
    if (n || (t = t.toLowerCase()), this.pattern === t) {
      let v = {
        isMatch: !0,
        score: 0
      };
      return s && (v.indices = [[0, t.length - 1]]), v;
    }
    const {
      location: r,
      distance: o,
      threshold: i,
      findAllMatches: l,
      minMatchCharLength: c,
      ignoreLocation: u
    } = this.options;
    let a = [], d = 0, p = !1;
    this.chunks.forEach(({ pattern: v, alphabet: _, startIndex: A }) => {
      const { isMatch: L, score: N, indices: F } = cu(t, v, _, {
        location: r + A,
        distance: o,
        threshold: i,
        findAllMatches: l,
        minMatchCharLength: c,
        includeMatches: s,
        ignoreLocation: u
      });
      L && (p = !0), d += N, L && F && (a = [...a, ...F]);
    });
    let g = {
      isMatch: p,
      score: p ? d / this.chunks.length : 1
    };
    return p && s && (g.indices = a), g;
  }
}
class Mt {
  constructor(t) {
    this.pattern = t;
  }
  static isMultiMatch(t) {
    return ho(t, this.multiRegex);
  }
  static isSingleMatch(t) {
    return ho(t, this.singleRegex);
  }
  search() {
  }
}
function ho(e, t) {
  const n = e.match(t);
  return n ? n[1] : null;
}
class uu extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(t) {
    const n = t === this.pattern;
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class fu extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(t) {
    const n = t.indexOf(this.pattern) === -1;
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class du extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(t) {
    const n = t.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class hu extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(t) {
    const n = !t.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class pu extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(t) {
    const n = t.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [t.length - this.pattern.length, t.length - 1]
    };
  }
}
class mu extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(t) {
    const n = !t.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class ji extends Mt {
  constructor(t, {
    location: n = z.location,
    threshold: s = z.threshold,
    distance: r = z.distance,
    includeMatches: o = z.includeMatches,
    findAllMatches: i = z.findAllMatches,
    minMatchCharLength: l = z.minMatchCharLength,
    isCaseSensitive: c = z.isCaseSensitive,
    ignoreLocation: u = z.ignoreLocation
  } = {}) {
    super(t), this._bitapSearch = new Di(t, {
      location: n,
      threshold: s,
      distance: r,
      includeMatches: o,
      findAllMatches: i,
      minMatchCharLength: l,
      isCaseSensitive: c,
      ignoreLocation: u
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(t) {
    return this._bitapSearch.searchIn(t);
  }
}
class Hi extends Mt {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(t) {
    let n = 0, s;
    const r = [], o = this.pattern.length;
    for (; (s = t.indexOf(this.pattern, n)) > -1; )
      n = s + o, r.push([s, n - 1]);
    const i = !!r.length;
    return {
      isMatch: i,
      score: i ? 0 : 1,
      indices: r
    };
  }
}
const js = [
  uu,
  Hi,
  du,
  hu,
  mu,
  pu,
  fu,
  ji
], po = js.length, gu = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, _u = "|";
function vu(e, t = {}) {
  return e.split(_u).map((n) => {
    let s = n.trim().split(gu).filter((o) => o && !!o.trim()), r = [];
    for (let o = 0, i = s.length; o < i; o += 1) {
      const l = s[o];
      let c = !1, u = -1;
      for (; !c && ++u < po; ) {
        const a = js[u];
        let d = a.isMultiMatch(l);
        d && (r.push(new a(d, t)), c = !0);
      }
      if (!c)
        for (u = -1; ++u < po; ) {
          const a = js[u];
          let d = a.isSingleMatch(l);
          if (d) {
            r.push(new a(d, t));
            break;
          }
        }
    }
    return r;
  });
}
const yu = /* @__PURE__ */ new Set([ji.type, Hi.type]);
class bu {
  constructor(t, {
    isCaseSensitive: n = z.isCaseSensitive,
    includeMatches: s = z.includeMatches,
    minMatchCharLength: r = z.minMatchCharLength,
    ignoreLocation: o = z.ignoreLocation,
    findAllMatches: i = z.findAllMatches,
    location: l = z.location,
    threshold: c = z.threshold,
    distance: u = z.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: n,
      includeMatches: s,
      minMatchCharLength: r,
      findAllMatches: i,
      ignoreLocation: o,
      location: l,
      threshold: c,
      distance: u
    }, this.pattern = n ? t : t.toLowerCase(), this.query = vu(this.pattern, this.options);
  }
  static condition(t, n) {
    return n.useExtendedSearch;
  }
  searchIn(t) {
    const n = this.query;
    if (!n)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: s, isCaseSensitive: r } = this.options;
    t = r ? t : t.toLowerCase();
    let o = 0, i = [], l = 0;
    for (let c = 0, u = n.length; c < u; c += 1) {
      const a = n[c];
      i.length = 0, o = 0;
      for (let d = 0, p = a.length; d < p; d += 1) {
        const g = a[d], { isMatch: v, indices: _, score: A } = g.search(t);
        if (v) {
          if (o += 1, l += A, s) {
            const L = g.constructor.type;
            yu.has(L) ? i = [...i, ..._] : i.push(_);
          }
        } else {
          l = 0, o = 0, i.length = 0;
          break;
        }
      }
      if (o) {
        let d = {
          isMatch: !0,
          score: l / o
        };
        return s && (d.indices = i), d;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const Hs = [];
function wu(...e) {
  Hs.push(...e);
}
function Vs(e, t) {
  for (let n = 0, s = Hs.length; n < s; n += 1) {
    let r = Hs[n];
    if (r.condition(e, t))
      return new r(e, t);
  }
  return new Di(e, t);
}
const zn = {
  AND: "$and",
  OR: "$or"
}, Ks = {
  PATH: "$path",
  PATTERN: "$val"
}, Bs = (e) => !!(e[zn.AND] || e[zn.OR]), xu = (e) => !!e[Ks.PATH], Su = (e) => !pt(e) && $i(e) && !Bs(e), mo = (e) => ({
  [zn.AND]: Object.keys(e).map((t) => ({
    [t]: e[t]
  }))
});
function Vi(e, t, { auto: n = !0 } = {}) {
  const s = (r) => {
    let o = Object.keys(r);
    const i = xu(r);
    if (!i && o.length > 1 && !Bs(r))
      return s(mo(r));
    if (Su(r)) {
      const c = i ? r[Ks.PATH] : o[0], u = i ? r[Ks.PATTERN] : r[c];
      if (!it(u))
        throw new Error(Ga(c));
      const a = {
        keyId: Ds(c),
        pattern: u
      };
      return n && (a.searcher = Vs(u, t)), a;
    }
    let l = {
      children: [],
      operator: o[0]
    };
    return o.forEach((c) => {
      const u = r[c];
      pt(u) && u.forEach((a) => {
        l.children.push(s(a));
      });
    }), l;
  };
  return Bs(e) || (e = mo(e)), s(e);
}
function Cu(e, { ignoreFieldNorm: t = z.ignoreFieldNorm }) {
  e.forEach((n) => {
    let s = 1;
    n.matches.forEach(({ key: r, norm: o, score: i }) => {
      const l = r ? r.weight : null;
      s *= Math.pow(
        i === 0 && l ? Number.EPSILON : i,
        (l || 1) * (t ? 1 : o)
      );
    }), n.score = s;
  });
}
function Eu(e, t) {
  const n = e.matches;
  t.matches = [], Ve(n) && n.forEach((s) => {
    if (!Ve(s.indices) || !s.indices.length)
      return;
    const { indices: r, value: o } = s;
    let i = {
      indices: r,
      value: o
    };
    s.key && (i.key = s.key.src), s.idx > -1 && (i.refIndex = s.idx), t.matches.push(i);
  });
}
function Tu(e, t) {
  t.score = e.score;
}
function Mu(e, t, {
  includeMatches: n = z.includeMatches,
  includeScore: s = z.includeScore
} = {}) {
  const r = [];
  return n && r.push(Eu), s && r.push(Tu), e.map((o) => {
    const { idx: i } = o, l = {
      item: t[i],
      refIndex: i
    };
    return r.length && r.forEach((c) => {
      c(o, l);
    }), l;
  });
}
class Vt {
  constructor(t, n = {}, s) {
    this.options = ye(ye({}, z), n), this.options.useExtendedSearch, this._keyStore = new Xa(this.options.keys), this.setCollection(t, s);
  }
  setCollection(t, n) {
    if (this._docs = t, n && !(n instanceof dr))
      throw new Error(za);
    this._myIndex = n || Pi(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(t) {
    Ve(t) && (this._docs.push(t), this._myIndex.add(t));
  }
  remove(t = () => !1) {
    const n = [];
    for (let s = 0, r = this._docs.length; s < r; s += 1) {
      const o = this._docs[s];
      t(o, s) && (this.removeAt(s), s -= 1, r -= 1, n.push(o));
    }
    return n;
  }
  removeAt(t) {
    this._docs.splice(t, 1), this._myIndex.removeAt(t);
  }
  getIndex() {
    return this._myIndex;
  }
  search(t, { limit: n = -1 } = {}) {
    const {
      includeMatches: s,
      includeScore: r,
      shouldSort: o,
      sortFn: i,
      ignoreFieldNorm: l
    } = this.options;
    let c = it(t) ? it(this._docs[0]) ? this._searchStringList(t) : this._searchObjectList(t) : this._searchLogical(t);
    return Cu(c, { ignoreFieldNorm: l }), o && c.sort(i), Ri(n) && n > -1 && (c = c.slice(0, n)), Mu(c, this._docs, {
      includeMatches: s,
      includeScore: r
    });
  }
  _searchStringList(t) {
    const n = Vs(t, this.options), { records: s } = this._myIndex, r = [];
    return s.forEach(({ v: o, i, n: l }) => {
      if (!Ve(o))
        return;
      const { isMatch: c, score: u, indices: a } = n.searchIn(o);
      c && r.push({
        item: o,
        idx: i,
        matches: [{ score: u, value: o, norm: l, indices: a }]
      });
    }), r;
  }
  _searchLogical(t) {
    const n = Vi(t, this.options), s = (l, c, u) => {
      if (!l.children) {
        const { keyId: d, searcher: p } = l, g = this._findMatches({
          key: this._keyStore.get(d),
          value: this._myIndex.getValueForItemAtKeyId(c, d),
          searcher: p
        });
        return g && g.length ? [
          {
            idx: u,
            item: c,
            matches: g
          }
        ] : [];
      }
      const a = [];
      for (let d = 0, p = l.children.length; d < p; d += 1) {
        const g = l.children[d], v = s(g, c, u);
        if (v.length)
          a.push(...v);
        else if (l.operator === zn.AND)
          return [];
      }
      return a;
    }, r = this._myIndex.records, o = {}, i = [];
    return r.forEach(({ $: l, i: c }) => {
      if (Ve(l)) {
        let u = s(n, l, c);
        u.length && (o[c] || (o[c] = { idx: c, item: l, matches: [] }, i.push(o[c])), u.forEach(({ matches: a }) => {
          o[c].matches.push(...a);
        }));
      }
    }), i;
  }
  _searchObjectList(t) {
    const n = Vs(t, this.options), { keys: s, records: r } = this._myIndex, o = [];
    return r.forEach(({ $: i, i: l }) => {
      if (!Ve(i))
        return;
      let c = [];
      s.forEach((u, a) => {
        c.push(
          ...this._findMatches({
            key: u,
            value: i[a],
            searcher: n
          })
        );
      }), c.length && o.push({
        idx: l,
        item: i,
        matches: c
      });
    }), o;
  }
  _findMatches({ key: t, value: n, searcher: s }) {
    if (!Ve(n))
      return [];
    let r = [];
    if (pt(n))
      n.forEach(({ v: o, i, n: l }) => {
        if (!Ve(o))
          return;
        const { isMatch: c, score: u, indices: a } = s.searchIn(o);
        c && r.push({
          score: u,
          key: t,
          value: o,
          idx: i,
          norm: l,
          indices: a
        });
      });
    else {
      const { v: o, n: i } = n, { isMatch: l, score: c, indices: u } = s.searchIn(o);
      l && r.push({ score: c, key: t, value: o, norm: i, indices: u });
    }
    return r;
  }
}
Vt.version = "6.6.2";
Vt.createIndex = Pi;
Vt.parseIndex = iu;
Vt.config = z;
Vt.parseQuery = Vi;
wu(bu);
const Ut = Zt({
  selectedNode: "",
  selectedGroup: "",
  shouldRerender: !1,
  /** Value of the search query. */
  search: "",
  filtered: {
    /** The count of all visible items. */
    count: 0,
    /** Map from visible item id. */
    items: /* @__PURE__ */ new Map(),
    /** Set of groups with at least one visible item. */
    groups: /* @__PURE__ */ new Set()
  }
}), Kt = () => ye({
  isSearching: we(() => Ut.search !== ""),
  resetStore: () => {
    Ut.search = "", Ut.filtered.count = 0, Ut.filtered.items = /* @__PURE__ */ new Map(), Ut.filtered.groups = /* @__PURE__ */ new Set();
  }
}, Rl(Ut));
function Au(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var s = e.get(t);
    s ? s.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var s = e.get(t);
    s && (n ? s.splice(s.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var s = e.get(t);
    s && s.slice().map(function(r) {
      r(n);
    }), (s = e.get("*")) && s.slice().map(function(r) {
      r(t, n);
    });
  } };
}
const ku = Au(), cs = () => ({
  emitter: ku
});
function Iu(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.nextElementSibling;
  }
}
function Ou(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.previousElementSibling;
  }
}
const Lu = ["command-theme"], Ru = { "command-root": "" }, $u = /* @__PURE__ */ xe({
  name: "CommandRoot"
}), Us = /* @__PURE__ */ xe(kt(ye({}, $u), {
  props: {
    theme: {
      type: String,
      default: "default"
    },
    fuseOptions: {
      type: Object,
      default: () => ({
        threshold: 0.2,
        keys: ["label"]
      })
    }
  },
  emits: ["select-item"],
  setup(e, { emit: t }) {
    const n = e, s = '[command-item=""]', r = "command-item-key", o = '[command-group=""]', i = "command-group-key", l = '[command-group-heading=""]', c = `${s}:not([aria-disabled="true"])`, u = `${s}[aria-selected="true"]`, a = "command-item-select", d = "data-value";
    li("theme", n.theme || "default");
    const { selectedNode: p, search: g, filtered: v, shouldRerender: _ } = Kt(), { emitter: A } = cs(), L = ge(), N = ws(ge(/* @__PURE__ */ new Map()), 333), F = ws(ge(/* @__PURE__ */ new Set()), 333), T = ws(ge(/* @__PURE__ */ new Map())), H = we(() => {
      const I = [];
      for (const [te, ee] of N.value.entries())
        I.push({
          key: te,
          label: ee
        });
      return I;
    }), J = we(() => {
      const I = Vt.createIndex(
        n.fuseOptions.keys,
        H.value
      );
      return new Vt(H.value, n.fuseOptions, I);
    }), Q = () => {
      var I, te, ee;
      const oe = U();
      oe && (((I = oe.parentElement) == null ? void 0 : I.firstElementChild) === oe && ((ee = (te = oe.closest(o)) == null ? void 0 : te.querySelector(l)) == null || ee.scrollIntoView({ block: "nearest" })), oe.scrollIntoView({ block: "nearest" }));
    }, U = () => {
      var I;
      return (I = L.value) == null ? void 0 : I.querySelector(u);
    }, O = () => {
      var I;
      const te = (I = L.value) == null ? void 0 : I.querySelectorAll(
        o
      );
      return te ? Array.from(te) : [];
    }, W = (I = L.value) => {
      const te = I == null ? void 0 : I.querySelectorAll(
        s
      );
      return te ? Array.from(te) : [];
    }, Z = (I = L.value) => {
      const te = I == null ? void 0 : I.querySelectorAll(
        c
      );
      return te ? Array.from(te) : [];
    }, E = () => {
      const [I] = Z();
      I && I.getAttribute(r) && (p.value = I.getAttribute(r) || "");
    }, B = (I) => {
      const te = Z()[I];
      te && (p.value = te.getAttribute(r) || "");
    }, ae = (I) => {
      const te = U(), ee = Z(), oe = ee.findIndex((Ye) => Ye === te), Ie = ee[oe + I];
      Ie ? p.value = Ie.getAttribute(r) || "" : I > 0 ? B(0) : B(ee.length - 1);
    }, $ = (I) => {
      const te = U();
      let ee = te == null ? void 0 : te.closest(o), oe = null;
      for (; ee && !oe; )
        ee = I > 0 ? Iu(ee, o) : Ou(ee, o), oe = ee == null ? void 0 : ee.querySelector(c);
      oe ? p.value = oe.getAttribute(r) || "" : ae(I);
    }, K = () => B(0), P = () => B(Z().length - 1), Y = (I) => {
      I.preventDefault(), I.metaKey ? P() : I.altKey ? $(1) : ae(1);
    }, Ee = (I) => {
      I.preventDefault(), I.metaKey ? K() : I.altKey ? $(-1) : ae(-1);
    }, ct = (I) => {
      switch (I.key) {
        case "n":
        case "j": {
          I.ctrlKey && Y(I);
          break;
        }
        case "ArrowDown": {
          Y(I);
          break;
        }
        case "p":
        case "k": {
          I.ctrlKey && Ee(I);
          break;
        }
        case "ArrowUp": {
          Ee(I);
          break;
        }
        case "Home": {
          K();
          break;
        }
        case "End": {
          P();
          break;
        }
        case "Enter": {
          const te = U();
          if (te) {
            const ee = new Event(a);
            te.dispatchEvent(ee);
          }
        }
      }
    }, Pe = () => {
      if (!g.value) {
        v.value.count = F.value.size;
        return;
      }
      v.value.groups = /* @__PURE__ */ new Set();
      const I = /* @__PURE__ */ new Map(), te = J.value.search(g.value).map((ee) => ee.item);
      for (const { key: ee, label: oe } of te)
        I.set(ee, oe);
      for (const [ee, oe] of T.value)
        for (const Ie of oe)
          I.get(Ie) && v.value.groups.add(ee);
      v.value.count = I.size, v.value.items = I;
    }, Te = () => {
      const I = O(), te = W();
      for (const ee of te) {
        const oe = ee.getAttribute(r) || "", Ie = ee.getAttribute(d) || "";
        F.value.add(oe), N.value.set(oe, Ie), v.value.count = N.value.size;
      }
      for (const ee of I) {
        const oe = W(ee), Ie = ee.getAttribute(i) || "", Ye = new Set("");
        for (const Xe of oe) {
          const tn = Xe.getAttribute(r) || "";
          Ye.add(tn);
        }
        T.value.set(Ie, Ye);
      }
    };
    We(
      () => p.value,
      (I) => {
        I && Pt(Q);
      },
      { deep: !0 }
    ), We(
      () => g.value,
      () => {
        _.value || (Pe(), Pt(E));
      }
    ), A.on("selectItem", (I) => {
      t("select-item", I);
    });
    const At = (I) => {
      I && (_.value = I, Te(), Pt(() => {
        Pe(), E(), _.value = !1;
      }));
    };
    return A.on("rerenderList", At), rs(() => {
      Te(), Pt(E);
    }), (I, te) => (X(), ce("div", {
      class: Zn(e.theme),
      onKeydown: ct,
      ref_key: "commandRef",
      ref: L,
      "command-theme": e.theme
    }, [
      R("div", Ru, [
        jt(I.$slots, "default")
      ])
    ], 42, Lu));
  }
})), Nu = { "command-dialog": "" }, Fu = { "command-dialog-mask": "" }, Pu = { "command-dialog-wrapper": "" }, Du = { "command-dialog-header": "" }, ju = { "command-dialog-body": "" }, Hu = {
  key: 0,
  "command-dialog-footer": ""
}, Vu = /* @__PURE__ */ xe({
  name: "Command.Dialog"
}), Ku = /* @__PURE__ */ xe(kt(ye({}, Vu), {
  props: {
    visible: { type: Boolean },
    theme: {}
  },
  emits: ["select-item"],
  setup(e, { emit: t }) {
    const n = e, { resetStore: s } = Kt(), { emitter: r } = cs(), o = ge();
    return r.on("selectItem", (i) => {
      t("select-item", i);
    }), Oi(() => n.visible, s), Sn(s), (i, l) => (X(), He(Ul, {
      to: "body",
      ref_key: "dialogRef",
      ref: o
    }, [
      le(Zc, {
        name: "command-dialog",
        appear: ""
      }, {
        default: rt(() => [
          i.visible ? (X(), He(Us, {
            key: 0,
            theme: i.theme
          }, {
            default: rt(() => [
              R("div", Nu, [
                R("div", Fu, [
                  R("div", Pu, [
                    R("div", Du, [
                      jt(i.$slots, "header")
                    ]),
                    R("div", ju, [
                      jt(i.$slots, "body")
                    ]),
                    i.$slots.footer ? (X(), ce("div", Hu, [
                      jt(i.$slots, "footer")
                    ])) : ze("", !0)
                  ])
                ])
              ])
            ]),
            _: 3
          }, 8, ["theme"])) : ze("", !0)
        ]),
        _: 3
      })
    ], 512));
  }
}));
let Ki = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((t, n) => (n &= 63, n < 36 ? t += n.toString(36) : n < 62 ? t += (n - 26).toString(36).toUpperCase() : n > 62 ? t += "-" : t += "_", t), "");
const Bu = ["command-group-key", "data-value"], Uu = {
  key: 0,
  "command-group-heading": ""
}, Wu = {
  "command-group-items": "",
  role: "group"
}, qu = /* @__PURE__ */ xe({
  name: "Command.Group"
}), zu = /* @__PURE__ */ xe(kt(ye({}, qu), {
  props: {
    heading: {}
  },
  setup(e) {
    const t = we(() => `command-group-${Ki()}`), { filtered: n, isSearching: s } = Kt(), r = we(
      () => s.value ? n.value.groups.has(t.value) : !0
    );
    return (o, i) => rr((X(), ce("div", {
      "command-group": "",
      role: "presentation",
      key: t.value,
      "command-group-key": t.value,
      "data-value": o.heading
    }, [
      o.heading ? (X(), ce("div", Uu, pe(o.heading), 1)) : ze("", !0),
      R("div", Wu, [
        jt(o.$slots, "default")
      ])
    ], 8, Bu)), [
      [Ai, r.value]
    ]);
  }
})), Gu = ["placeholder", "value"], Ju = /* @__PURE__ */ xe({
  name: "Command.Input"
}), Qu = /* @__PURE__ */ xe(kt(ye({}, Ju), {
  props: {
    placeholder: {},
    value: {}
  },
  emits: ["input", "update:value"],
  setup(e, { emit: t }) {
    const n = ge(null), { search: s } = Kt(), r = we(() => s.value), o = (i) => {
      const l = i, c = i.target;
      s.value = c == null ? void 0 : c.value, t("input", l), t("update:value", s.value);
    };
    return cr(() => {
      var i;
      (i = n.value) == null || i.focus();
    }), (i, l) => (X(), ce("input", {
      ref_key: "inputRef",
      ref: n,
      "command-input": "",
      "auto-focus": "",
      "auto-complete": "off",
      "auto-correct": "off",
      "spell-check": !1,
      "aria-autocomplete": "list",
      role: "combobox",
      "aria-expanded": !0,
      placeholder: i.placeholder,
      value: r.value,
      onInput: o
    }, null, 40, Gu));
  }
})), Yu = ["aria-selected", "aria-disabled", "command-item-key"], Xu = /* @__PURE__ */ xe({
  name: "Command.Item"
}), Zu = /* @__PURE__ */ xe(kt(ye({}, Xu), {
  props: {
    shortcut: {},
    perform: { type: Function }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, s = "command-item-select", r = "data-value", { current: o } = Pa(), { selectedNode: i, filtered: l, isSearching: c } = Kt(), { emitter: u } = cs(), a = ge(), d = we(() => `command-item-${Ki()}`), p = we(() => {
      const _ = l.value.items.get(d.value);
      return c.value ? _ !== void 0 : !0;
    }), g = we(() => Array.from(o)), v = () => {
      var _;
      const A = {
        key: d.value,
        value: ((_ = a.value) == null ? void 0 : _.getAttribute(r)) || ""
      };
      t("select", A), u.emit("selectItem", A);
    };
    return Oi(g, (_) => {
      n.shortcut && n.shortcut.length > 0 && n.shortcut.every((A) => o.has(A.toLowerCase())) && n.perform && n.perform();
    }), cr(() => {
      var _;
      (_ = a.value) == null || _.addEventListener(s, v);
    }), Sn(() => {
      var _;
      (_ = a.value) == null || _.removeEventListener(s, v);
    }), (_, A) => rr((X(), ce("div", {
      ref_key: "itemRef",
      ref: a,
      "command-item": "",
      role: "option",
      "aria-selected": me(i) === d.value,
      "aria-disabled": !p.value,
      key: d.value,
      "command-item-key": d.value,
      onClick: v
    }, [
      jt(_.$slots, "default")
    ], 8, Yu)), [
      [Ai, p.value]
    ]);
  }
})), ef = /* @__PURE__ */ xe({
  name: "Command.List"
}), tf = /* @__PURE__ */ xe(kt(ye({}, ef), {
  setup(e) {
    const { emitter: t } = cs(), n = ge(), s = ge();
    let r = null, o;
    return cr(() => {
      o = s.value;
      const i = n.value;
      let l;
      if (o && i)
        return r = new ResizeObserver((c) => {
          l = requestAnimationFrame(() => {
            const u = o == null ? void 0 : o.offsetHeight;
            i == null || i.style.setProperty(
              "--command-list-height",
              `${u == null ? void 0 : u.toFixed(1)}px`
            ), t.emit("rerenderList", !0);
          });
        }), r.observe(o), () => {
          cancelAnimationFrame(l), r == null || r.unobserve(o);
        };
    }), Sn(() => {
      r !== null && o && r.unobserve(o);
    }), (i, l) => (X(), ce("div", {
      "command-list": "",
      role: "listbox",
      "aria-label": "Suggestions",
      ref_key: "listRef",
      ref: n
    }, [
      R("div", {
        "command-list-sizer": "",
        ref_key: "heightRef",
        ref: s
      }, [
        jt(i.$slots, "default")
      ], 512)
    ], 512));
  }
})), nf = /* @__PURE__ */ xe({
  name: "Command.Empty",
  setup(e, { attrs: t, slots: n }) {
    const { filtered: s } = Kt(), r = we(() => s.value.count === 0);
    return () => r.value ? en(
      "div",
      ye({
        "command-empty": "",
        role: "presentation"
      }, t),
      n
    ) : en("div", ye({
      "command-empty": "hidden",
      role: "presentation",
      style: {
        display: "none"
      }
    }, t));
  }
}), sf = /* @__PURE__ */ xe({
  name: "Command.Loading",
  setup(e, { attrs: t, slots: n }) {
    return () => en(
      "div",
      ye({
        "command-loading": "",
        role: "progressbar"
      }, t),
      n
    );
  }
}), rf = /* @__PURE__ */ xe({
  name: "Command.Separator",
  setup(e, { attrs: t, slots: n }) {
    return () => en("div", ye({
      "command-separator": "",
      role: "separator"
    }, t));
  }
}), vt = Object.assign(Us, {
  Root: Us,
  Dialog: Ku,
  Empty: nf,
  Group: zu,
  Input: Qu,
  Item: Zu,
  List: tf,
  Loading: sf,
  Separator: rf
}), of = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
};
function lf(e, t) {
  return X(), ce("svg", of, t[0] || (t[0] = [
    R("g", { "clip-path": "url(#a)" }, [
      R("path", { d: "m24 22.94-8.132-8.132A8.96 8.96 0 0 0 18 9a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9c2.216 0 4.24-.804 5.808-2.132L22.939 24zM9 16.5c-4.135 0-7.5-3.364-7.5-7.5 0-4.135 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5M9 3v1.5c2.481 0 4.5 2.019 4.5 4.5H15c0-3.309-2.691-6-6-6" })
    ], -1),
    R("defs", null, [
      R("clipPath", { id: "a" }, [
        R("path", { d: "M0 0h24v24H0z" })
      ])
    ], -1)
  ]));
}
const cf = { render: lf }, af = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
};
function uf(e, t) {
  return X(), ce("svg", af, t[0] || (t[0] = [
    R("path", { d: "m13.067 14-4.2-4.2a4.06 4.06 0 0 1-2.533.867q-1.818 0-3.076-1.259T2 6.333t1.258-3.075Q4.518 2 6.333 2 8.15 2 9.408 3.258q1.26 1.26 1.259 3.075A4.06 4.06 0 0 1 9.8 8.867l4.2 4.2zM6.333 9.333q1.25 0 2.125-.875a2.9 2.9 0 0 0 .875-2.125q0-1.25-.875-2.125a2.9 2.9 0 0 0-2.125-.875q-1.25 0-2.125.875a2.9 2.9 0 0 0-.875 2.125q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875" }, null, -1)
  ]));
}
const ff = { render: uf }, df = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
};
function hf(e, t) {
  return X(), ce("svg", df, t[0] || (t[0] = [
    R("mask", {
      id: "a",
      width: "16",
      height: "16",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: { "mask-type": "alpha" }
    }, [
      R("path", { d: "M0 0h16v16H0z" })
    ], -1),
    R("g", { mask: "url(#a)" }, [
      R("path", { d: "M5.4 8.8V3.9L3.65 5.65 2.8 4.8 6 1.6l3.2 3.2-.85.85L6.6 3.9v4.9zm4.6 5.6-3.2-3.2.85-.85L9.4 12.1V7.2h1.2v4.9l1.75-1.75.85.85z" })
    ], -1)
  ]));
}
const pf = { render: hf }, mf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
};
function gf(e, t) {
  return X(), ce("svg", mf, t[0] || (t[0] = [
    R("path", { d: "M6 12 2 8l4-4 .933.933-2.4 2.4h8.134V4.667H14v4H4.533l2.4 2.4z" }, null, -1)
  ]));
}
const Bi = { render: gf }, _f = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 32 32"
};
function vf(e, t) {
  return X(), ce("svg", _f, t[0] || (t[0] = [
    R("path", { d: "M6 16 22.514 0 24 1.44 8.974 16 24 30.56 22.514 32z" }, null, -1)
  ]));
}
const yf = { render: vf }, bf = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 16 16"
};
function wf(e, t) {
  return X(), ce("svg", bf, t[0] || (t[0] = [
    Fc('<linearGradient id="a" x1="16.125" x2=".48" y1="2.953" y2="6.309" gradientUnits="userSpaceOnUse"><stop offset=".157" style="stop-color:#387dc5;"></stop><stop offset="1" style="stop-color:#387dc5;stop-opacity:.5;"></stop></linearGradient><path d="M16 7.9h-2c0-3.3-2.7-6-6-6s-6 2.7-6 6H0c0-4.4 3.6-8 8-8s8 3.6 8 8" style="fill-rule:evenodd;clip-rule:evenodd;fill:url(#a);"></path><linearGradient id="b" x1="19.836" x2="5.431" y1="3.784" y2="6.874" gradientTransform="matrix(1 0 0 -1 -5.002 16.414)" gradientUnits="userSpaceOnUse"><stop offset=".045" style="stop-color:#387dc5;stop-opacity:0;"></stop><stop offset=".924" style="stop-color:#387dc5;stop-opacity:.5;"></stop></linearGradient><path d="M16 7.9h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6H0c0 4.4 3.6 8 8 8s8-3.6 8-8" style="fill-rule:evenodd;clip-rule:evenodd;fill:url(#b);"></path>', 4)
  ]));
}
const xf = { render: wf }, Sf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "16"
};
function Cf(e, t) {
  return X(), ce("svg", Sf, t[0] || (t[0] = [
    R("path", {
      "fill-rule": "evenodd",
      d: "M39 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5 8.37.56-.75s.75.76 1.8.76c.66 0 1.22-.37 1.22-1.04 0-.698-.712-1.01-1.487-1.347C6.171 7.59 5.16 7.15 5.16 5.97c0-1.1.95-1.97 2.28-1.97 1.31 0 2 .71 2 .71l-.45.82s-.65-.61-1.55-.61c-.75 0-1.28.47-1.28 1.03 0 .648.674.932 1.424 1.247.939.395 1.996.84 1.996 2.113 0 1.09-.84 1.99-2.24 1.99-1.5 0-2.34-.93-2.34-.93m25.818.81V4.12h.97v2.59c0 .24-.02.42-.02.42h.02c.22-.49.86-1.13 1.87-1.13 1.19 0 1.74.65 1.74 1.94v3.24h-.97V8.16c0-.71-.15-1.27-.96-1.27-.76 0-1.39.52-1.6 1.25-.06.2-.08.43-.08.67v2.37zM24.99 8.65c0-1.5 1.12-2.65 2.71-2.65 1.27 0 1.9.74 1.9.74l-.46.68s-.54-.58-1.4-.58c-1.02 0-1.76.76-1.76 1.8 0 1.03.74 1.82 1.79 1.82.94 0 1.56-.68 1.56-.68l.39.71s-.7.81-2.02.81c-1.59 0-2.71-1.13-2.71-2.65m-3.36-2.53v5.06h.97V9.11c0-.31.03-.62.12-.91.23-.75.8-1.19 1.42-1.19.15 0 .28.03.28.03v-.96s-.12-.02-.25-.02c-.78 0-1.37.58-1.6 1.32h-.02s.02-.17.02-.38v-.88zm-5.694 3.64c0-1.67 2.2-1.74 3.05-1.74h.22v-.09c0-.83-.47-1.11-1.11-1.11-.78 0-1.41.49-1.41.49l-.4-.71s.73-.6 1.89-.6c1.28 0 2 .7 2 1.98v3.2h-.9v-.48c0-.23.02-.4.02-.4h-.02s-.41 1-1.62 1c-.87 0-1.72-.53-1.72-1.54m.98-.05c0 .41.32.81.95.81.82 0 1.35-.86 1.35-1.61v-.16h-.25c-.73 0-2.05.05-2.05.96M12.98 6c-1.44 0-2.53 1.04-2.53 2.65 0 1.5 1.09 2.65 2.68 2.65 1.21 0 1.96-.72 1.96-.72l-.4-.71s-.63.59-1.5.59c-.9 0-1.69-.56-1.74-1.67h3.69s.03-.29.03-.42c0-1.31-.76-2.37-2.19-2.37m1.2 2.06h-2.7c.14-.83.74-1.29 1.48-1.29.65 0 1.19.42 1.22 1.29",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ef = { render: Cf }, Tf = ["src"], Mf = /* @__PURE__ */ xe({
  __name: "VrmAvatar",
  props: {
    avatarUrl: {
      type: String
    }
  },
  setup(e) {
    const t = e, n = we(() => t.avatarUrl ? t.avatarUrl : "/images/thumb-default.png");
    return (s, r) => (X(), ce("img", { src: n.value }, null, 8, Tf));
  }
}), Af = { class: "search-item__image" }, kf = { class: "search-item__description" }, If = { class: "search-item__description__title" }, Of = {
  key: 0,
  class: "search-item__description__highlights"
}, Lf = ["innerHTML"], Rf = {
  __name: "EnhancedSearchItem",
  props: {
    result: {
      type: Object,
      required: !0
    },
    parsedTranslationsSearch: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = we(() => {
      const r = t.result.highlight;
      let o = 0, i = "", l = "";
      return Object.entries(r).forEach(([c, u]) => {
        u.forEach((a) => {
          const d = (a.match(/<em>(.*?)<\/em>/g) || []).reduce(
            (p, g) => p + g.length,
            0
          );
          d > o && (o = d, i = a, l = c);
        });
      }), { bestHighlight: i, bestHighlightKey: l };
    }), s = we(() => {
      switch (n.value.bestHighlightKey) {
        case "site_name":
          return t.parsedTranslationsSearch.site_name;
        case "site_emails.value":
          return t.parsedTranslationsSearch.site_emails;
        case "site_usernames.value":
          return t.parsedTranslationsSearch.site_usernames;
        case "site_serials.value":
          return t.parsedTranslationsSearch.site_serials;
        case "site_emails.domain":
          return t.parsedTranslationsSearch.site_emails_domain;
        case "site_identifier":
          return t.parsedTranslationsSearch.site_identifier;
        case "site_id":
          return t.parsedTranslationsSearch.site_id;
        default:
          return null;
      }
    });
    return (r, o) => (X(), ce(be, null, [
      R("div", Af, [
        le(Mf, {
          avatarUrl: e.result.avatar_url
        }, null, 8, ["avatarUrl"])
      ]),
      R("div", kf, [
        R("p", If, pe(e.result.site_name), 1),
        e.result.highlight ? (X(), ce("p", Of, [
          R("span", null, pe(s.value), 1),
          o[0] || (o[0] = St(" | ")),
          R("span", {
            innerHTML: n.value.bestHighlight
          }, null, 8, Lf)
        ])) : ze("", !0)
      ])
    ], 64));
  }
}, $f = { class: "enhanced-search-instructions__intro" }, Nf = { key: 0 }, Ff = { key: 1 }, Pf = { class: "enhanced-search-instructions__title" }, Df = {
  __name: "EnhancedSearchInstructions",
  props: {
    parsedTranslationsSearch: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (n, s) => {
      var r, o, i, l, c, u, a, d, p, g, v, _, A, L, N, F, T, H, J, Q, U, O, W, Z, E, B;
      return X(), ce(be, null, [
        R("p", $f, [
          St(pe((o = (r = t.parsedTranslationsSearch) == null ? void 0 : r.instructions) == null ? void 0 : o.to_start) + " ", 1),
          n.isMobile ? (X(), ce("span", Nf, [
            le(me(Ef))
          ])) : (X(), ce("span", Ff, [
            le(me(Bi))
          ])),
          St(" " + pe((l = (i = t.parsedTranslationsSearch) == null ? void 0 : i.instructions) == null ? void 0 : l.or_click) + " ", 1),
          R("span", null, [
            le(me(ff))
          ]),
          St(" " + pe((u = (c = t.parsedTranslationsSearch) == null ? void 0 : c.instructions) == null ? void 0 : u.icon), 1)
        ]),
        R("p", Pf, pe((d = (a = t.parsedTranslationsSearch) == null ? void 0 : a.instructions) == null ? void 0 : d.search_by), 1),
        R("ul", null, [
          R("li", null, pe((v = (g = (p = t.parsedTranslationsSearch) == null ? void 0 : p.instructions) == null ? void 0 : g.searchByOptions) == null ? void 0 : v.installation_name), 1),
          R("li", null, pe((L = (A = (_ = t.parsedTranslationsSearch) == null ? void 0 : _.instructions) == null ? void 0 : A.searchByOptions) == null ? void 0 : L.installation_id), 1),
          R("li", null, pe((T = (F = (N = t.parsedTranslationsSearch) == null ? void 0 : N.instructions) == null ? void 0 : F.searchByOptions) == null ? void 0 : T.vrm_portal_id), 1),
          R("li", null, pe((Q = (J = (H = t.parsedTranslationsSearch) == null ? void 0 : H.instructions) == null ? void 0 : J.searchByOptions) == null ? void 0 : Q.user_email_address), 1),
          R("li", null, pe((W = (O = (U = t.parsedTranslationsSearch) == null ? void 0 : U.instructions) == null ? void 0 : O.searchByOptions) == null ? void 0 : W.device_serial), 1),
          R("li", null, pe((B = (E = (Z = t.parsedTranslationsSearch) == null ? void 0 : Z.instructions) == null ? void 0 : E.searchByOptions) == null ? void 0 : B.email_domain) + " ('@victronenergy.com') ", 1)
        ])
      ], 64);
    };
  }
}, jf = { class: "enhanced-search-no-results__number" }, Hf = { class: "enhanced-search-no-results__intro" }, Vf = { class: "enhanced-search-no-results__intro__search-term" }, Kf = { class: "enhanced-search-no-results__hints" }, Bf = {
  __name: "EnhancedSearchNoResultsFound",
  props: {
    parsedTranslationsSearch: {
      type: Object,
      required: !0
    },
    searchTermOnFail: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (n, s) => {
      var r, o, i, l, c, u, a;
      return X(), ce(be, null, [
        R("p", jf, "0 " + pe((r = t.parsedTranslationsSearch) == null ? void 0 : r.installations_found), 1),
        R("p", Hf, [
          St(pe((i = (o = t.parsedTranslationsSearch) == null ? void 0 : o.noResult) == null ? void 0 : i.no_installations_found) + " ", 1),
          R("span", Vf, pe(t.searchTermOnFail), 1)
        ]),
        R("ul", Kf, [
          R("li", null, pe((c = (l = t.parsedTranslationsSearch) == null ? void 0 : l.noResults) == null ? void 0 : c.hint_1), 1),
          R("li", null, pe((a = (u = t.parsedTranslationsSearch) == null ? void 0 : u.noResults) == null ? void 0 : a.hint_2), 1)
        ])
      ], 64);
    };
  }
}, Uf = ["data-theme"], Wf = { class: "header" }, qf = { class: "header__back" }, zf = { class: "header__form" }, Gf = ["placeholder"], Jf = { class: "header__form__search-icon" }, Qf = {
  key: 2,
  class: "enhanced-search-instructions"
}, Yf = {
  key: 3,
  class: "enhanced-search-no-results"
}, Xf = {
  key: 0,
  class: "footer"
}, Zf = { class: "footer-icon" }, ed = { class: "footer-icon" }, td = /* @__PURE__ */ xe({
  __name: "App.ce",
  props: {
    theme: {
      type: String
    },
    translations: {
      type: String
    },
    translationsSearch: {
      type: String
    },
    disabled: {
      type: String,
      default: "false"
    },
    showFleetMonitor: {
      type: String,
      default: !1
    },
    searchResults: {
      type: Array
    }
  },
  emits: ["select", "enhanced-search"],
  setup(e, { emit: t }) {
    const { search: n } = Kt(), s = ge(!1), r = ge(window.innerWidth < 768), o = ge({}), i = ge({}), l = ge(""), c = ge(!1), u = ge(!0), a = ge(!1), d = ge(""), p = ge(!1);
    let g = null;
    const v = t, _ = e, A = ge(_.searchResults || []);
    We(() => _.searchResults, ($) => {
      A.value = $, u.value = !1, c.value = !1, $.length === 0 && (a.value = !0, d.value = l.value);
    }), rs(() => {
      window.addEventListener("keydown", L), window.addEventListener("resize", F);
    }), or(() => {
      window.removeEventListener("keydown", L), window.removeEventListener("resize", F);
    });
    const L = async ($) => {
      if (_.disabled !== "true") {
        if (($.ctrlKey || $.metaKey) && ($.key === "k" || $.key === "/")) {
          $.preventDefault(), s.value = !0, await Pt();
          const K = document.querySelector("vrm-command-k");
          if (K != null && K.shadowRoot) {
            const P = K.shadowRoot.querySelector(".command-k-input");
            P == null || P.focus();
          }
          window.dataLayer = window.dataLayer || [], window.dataLayer.push({
            event: "CmdKTriggered",
            page_path: window.location.pathname,
            page_title: document.title
          });
        }
        s.value && $.key === "Escape" && ($.preventDefault(), N());
      }
    }, N = () => {
      s.value = !1, l.value === "" && (A.value = []);
    }, F = () => {
      r.value = window.innerWidth < 768;
    }, T = ($) => {
      n.value = "", v("select", $), N();
    };
    We(() => _.translations, ($) => {
      $ && (o.value = JSON.parse($));
    }, { immediate: !0 }), We(() => _.translationsSearch, ($) => {
      $ && (i.value = JSON.parse($));
    }, { immediate: !0 });
    const H = we(() => {
      var K, P, Y, Ee, ct, Pe, Te, At, I, te, ee, oe, Ie, Ye, Xe, tn, f, h, m, b;
      const $ = [
        { value: (K = o.value) == null ? void 0 : K.installationOverview, label: (P = o.value) == null ? void 0 : P.installationOverview, routeName: "installation_overview" },
        { value: (Y = o.value) == null ? void 0 : Y.dashboard, label: (Ee = o.value) == null ? void 0 : Ee.dashboard, routeName: "dashboard" },
        { value: (ct = o.value) == null ? void 0 : ct.advanced, label: (Pe = o.value) == null ? void 0 : Pe.advanced, routeName: "advanced" },
        { value: (Te = o.value) == null ? void 0 : Te.alarmLogs, label: (At = o.value) == null ? void 0 : At.alarmLogs, routeName: "alarm_logs" },
        { value: (I = o.value) == null ? void 0 : I.deviceList, label: (te = o.value) == null ? void 0 : te.deviceList, routeName: "device_list" },
        { value: (ee = o.value) == null ? void 0 : ee.eventLogs, label: (oe = o.value) == null ? void 0 : oe.eventLogs, routeName: "event_logs" },
        { value: (Ie = o.value) == null ? void 0 : Ie.generalSettings, label: (Ye = o.value) == null ? void 0 : Ye.generalSettings, routeName: "general_settings" },
        { value: (Xe = o.value) == null ? void 0 : Xe.users, label: (tn = o.value) == null ? void 0 : tn.users, routeName: "users" },
        { value: (f = o.value) == null ? void 0 : f.alarmRules, label: (h = o.value) == null ? void 0 : h.alarmRules, routeName: "alarm_rules" }
      ];
      return _.showFleetMonitor === "true" && $.splice(1, 0, { value: (m = o.value) == null ? void 0 : m.fleetMonitor, label: (b = o.value) == null ? void 0 : b.fleetMonitor, routeName: "fleet_monitor" }), $;
    }), J = we(() => {
      var $, K, P, Y, Ee;
      return {
        search: ($ = o.value) == null ? void 0 : $.search,
        select: (K = o.value) == null ? void 0 : K.select,
        open: (P = o.value) == null ? void 0 : P.open,
        close: (Y = o.value) == null ? void 0 : Y.close,
        navigation: (Ee = o.value) == null ? void 0 : Ee.navigation
      };
    });
    We(s, ($) => {
      $ ? window.addEventListener("keydown", Q) : window.removeEventListener("keydown", Q);
    });
    const Q = ($) => {
      const K = document.querySelector("vrm-command-k");
      let P;
      if (K && K.shadowRoot && (P = K.shadowRoot.querySelectorAll("div")[1]), !$.shiftKey && $.key === "Tab") {
        if ($.preventDefault(), P) {
          const Y = new KeyboardEvent("keydown", { key: "ArrowDown" });
          P.dispatchEvent(Y);
        }
      } else if ($.shiftKey && $.key === "Tab" && ($.preventDefault(), P)) {
        const Y = new KeyboardEvent("keydown", { key: "ArrowUp" });
        P.dispatchEvent(Y);
      }
    }, U = we(() => !window.location.pathname.includes("/installation")), O = () => {
      l.value.trim().length === 0 ? (a.value = !1, A.value = [], u.value = !0, v("enhanced-search", "")) : (a.value = !1, c.value = !0, v("enhanced-search", l.value));
    }, W = ($) => {
      l.value = "", u.value = !0, v("select-installation", $), N();
    }, E = (($, K) => function(...P) {
      p.value = !0, g && clearTimeout(g), g = setTimeout(() => {
        $(...P), g = null, p.value = !1;
      }, K);
    })(O, 1e3), B = () => {
      E();
    }, ae = ($) => {
      $.key === "Enter" && p.value && ($.preventDefault(), p.value = !1, g && clearTimeout(g), O());
    };
    return ($, K) => s.value ? (X(), ce("div", {
      key: 0,
      onMousedown: Ca(N, ["self"]),
      "data-theme": _.theme,
      class: "command-k-wrapper modal"
    }, [
      le(me(vt), null, {
        default: rt(() => [
          R("div", Wf, [
            R("div", qf, [
              le(me(yf), { onClick: N })
            ]),
            R("div", zf, [
              U.value ? rr((X(), ce("input", {
                key: 0,
                type: "text",
                class: "command-k-input",
                placeholder: J.value.search,
                "onUpdate:modelValue": K[0] || (K[0] = (P) => l.value = P),
                onInput: B,
                onKeydown: ae
              }, null, 40, Gf)), [
                [wa, l.value]
              ]) : (X(), He(me(vt).Input, {
                key: 1,
                placeholder: J.value.search
              }, null, 8, ["placeholder"])),
              K[1] || (K[1] = R("div", { class: "header__form__separator" }, null, -1)),
              R("div", Jf, [
                c.value ? (X(), He(me(xf), { key: 0 })) : (X(), He(me(cf), {
                  key: 1,
                  onClick: B
                }))
              ])
            ])
          ]),
          le(me(vt).List, null, {
            default: rt(() => [
              U.value && !u.value && !a.value ? (X(), He(me(vt).Group, {
                key: 0,
                heading: A.value.length > 0 ? `${A.value.length} ${i.value.installations_found}` : ""
              }, {
                default: rt(() => [
                  c.value ? (X(), He(me(vt).Loading, { key: 0 }, {
                    default: rt(() => K[2] || (K[2] = [
                      St("loading...")
                    ])),
                    _: 1
                  })) : ze("", !0),
                  (X(!0), ce(be, null, Er(A.value, (P) => (X(), He(me(vt).Item, {
                    class: "search-item",
                    key: P.site_id,
                    onSelect: (Y) => W(P.site_id)
                  }, {
                    default: rt(() => [
                      le(Rf, {
                        result: P,
                        parsedTranslationsSearch: i.value
                      }, null, 8, ["result", "parsedTranslationsSearch"])
                    ]),
                    _: 2
                  }, 1032, ["onSelect"]))), 128))
                ]),
                _: 1
              }, 8, ["heading"])) : ze("", !0),
              U.value ? ze("", !0) : (X(), He(me(vt).Group, {
                key: 1,
                heading: J.value.navigation
              }, {
                default: rt(() => [
                  (X(!0), ce(be, null, Er(H.value, (P) => (X(), He(me(vt).Item, {
                    "data-value": P.value,
                    onSelect: (Y) => T(P.routeName)
                  }, {
                    default: rt(() => [
                      St(pe(P.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-value", "onSelect"]))), 256))
                ]),
                _: 1
              }, 8, ["heading"])),
              U.value && u.value ? (X(), ce("div", Qf, [
                le(Df, { parsedTranslationsSearch: i.value }, null, 8, ["parsedTranslationsSearch"])
              ])) : ze("", !0),
              U.value && a.value ? (X(), ce("div", Yf, [
                le(Bf, {
                  parsedTranslationsSearch: i.value,
                  searchTermOnFail: d.value
                }, null, 8, ["parsedTranslationsSearch", "searchTermOnFail"])
              ])) : ze("", !0)
            ]),
            _: 1
          }),
          r.value ? ze("", !0) : (X(), ce("div", Xf, [
            R("div", null, [
              R("span", Zf, [
                le(me(pf))
              ]),
              R("span", null, pe(J.value.select), 1)
            ]),
            R("div", null, [
              R("span", ed, [
                le(me(Bi))
              ]),
              R("span", null, pe(J.value.open), 1)
            ]),
            R("div", null, [
              K[3] || (K[3] = R("span", { class: "footer-icon" }, "Esc", -1)),
              R("span", null, pe(J.value.close), 1)
            ])
          ]))
        ]),
        _: 1
      })
    ], 40, Uf)) : ze("", !0);
  }
}), nd = ".command-k-wrapper{font-size:16px!important;font-family:museo-sans,Tahoma,Verdana;position:fixed;top:0;left:0;width:100%;height:100%;background-color:var(--sg-color-black90);display:flex;justify-content:center;z-index:25000;padding-top:5em;font-weight:300;--sg-color-black: rgb(39, 38, 34);--sg-color-black90: rgba(39, 38, 34, .9);--sg-color-blue: rgb(71, 144, 208);--sg-color-grey: rgb(150, 149, 145);--sg-color-white: rgb(255, 255, 255);--sg-color-background: rgb(240, 239, 235);--sg-color-background-light: rgb(250, 249, 245);--sg-color-background-dark: rgb(230, 229, 225);--sg-color-grey-dark: rgb(100, 99, 95);--sg-color-grey-darker: rgb(80, 79, 75);--sg-color-grey-darker10: rgba(80, 79, 75, .1);--sg-color-border-grey: rgb(222, 221, 220);--dm-color-grey: #3c3c3c;--dm-color-grey-light: var(--sg-color-grey-dark);--dm-color-grey-lighter: var( --sg-color-grey-darker);--dm-color-grey-darker: #373737;--dm-color-text: var(--sg-color-background-light);--dm-color-border: var(--sg-color-grey-darker);--dm-color-border-light: var(--sg-color-grey);--dm-color-background: rgb(55, 55, 55);--dm-color-background-hover: rgb(46, 45, 45);--bg-header-color: var(--sg-color-white);--bg-body-color: var(--sg-color-background-light);--bg-footer-color: var(--sg-color-background-light);--bg-item-color-hover: var(--sg-color-grey-darker10);--text-color: var(--sg-color-black);--text-color-light: var(--sg-color-grey);--border-color: var(--sg-color-border-grey);--icon-color: var(--sg-color-grey);--scrollbar-bg-color: var(--sg-color-background-light);--scrollbar-thumb-color: var(--sg-color-grey-dark)}.command-k-wrapper[data-theme=dark]{--bg-header-color: var(--dm-color-background);--bg-body-color: var(--dm-color-background);--bg-footer-color: var(--dm-color-background);--bg-item-color-hover: var(--dm-color-background-hover);--text-color: var(--dm-color-text);--border-color: var(--dm-color-border);--scrollbar-bg-color: var(--dm-color-background);--scrollbar-thumb-color: var(--dm-color-border-light)}.command-k-wrapper .default{height:fit-content}.command-k-wrapper .header{display:flex;align-items:center;border-bottom:.1em solid var(--border-color);border-radius:.4em .4em 0 0;overflow:hidden}@media (max-width: 768px){.command-k-wrapper .header{padding:1em .8em;border-bottom:none}}.command-k-wrapper .header__back{padding-right:1em;cursor:pointer}.command-k-wrapper .header__back svg{color:var(--icon-color);fill:currentColor}@media (min-width: 768px){.command-k-wrapper .header__back{display:none}}.command-k-wrapper .header__form{display:flex;align-items:center;flex-grow:4;background-color:var(--bg-header-color);overflow:hidden}.command-k-wrapper .header__form:focus-within{border-color:var(--sg-color-border-grey)}@media (max-width: 768px){.command-k-wrapper .header__form{border-radius:.25em;border:1px solid var(--border-color)}}.command-k-wrapper .header__form__separator{border-left:1px solid var(--border-color);height:2.2em}.command-k-wrapper .header__form__search-icon{cursor:pointer;padding-inline:1em;display:flex;align-items:center}.command-k-wrapper .header__form__search-icon svg{height:1.4em;color:var(--icon-color);fill:currentColor}.command-k-wrapper .header__form__search-icon svg:hover{color:var(--sg-color-blue)}.command-k-wrapper .footer{display:flex;align-items:center;gap:2.4em;padding:.8em .9em;border-top:.1em solid var(--border-color);color:var(--text-color-light);font-size:.8em}.command-k-wrapper .footer div{display:flex;align-items:center}.command-k-wrapper .footer-icon{padding:.25em;border:1px solid var(--border-color);border-radius:.4em;margin-right:.4em;line-height:1;display:inline-flex;align-items:center;justify-content:center;min-height:1.2em;min-width:1.2em}.command-k-wrapper .footer-icon svg{color:var(--icon-color);fill:currentColor}[command-root]{width:38em;border-radius:.25em;color:var(--text-color);background-color:var(--bg-body-color)}@media (max-width: 768px){[command-root]{position:fixed;top:0;left:0;width:100%;height:100%;border-radius:0}}[command-root] [command-input],[command-root] .command-k-input{background-color:var(--bg-header-color);border:none;border-radius:.4em;height:3.6em;padding-inline:1em;flex-grow:4;font-size:1em;font-weight:300;color:var(--text-color)}[command-root] [command-input]::placeholder,[command-root] .command-k-input::placeholder{color:var(--sg-color-blue);font-weight:100}[command-root] [command-input]:focus,[command-root] .command-k-input:focus{outline:none;color:var(--sg-color-blue)}[command-root] [command-list]{padding-top:1.6em;font-size:16px}@media (min-width: 768px){[command-root] [command-list]{max-height:30em;min-height:20em;overflow-y:auto}}[command-root] [command-list]::-webkit-scrollbar{width:6px}[command-root] [command-list]::-webkit-scrollbar-track{background-color:var(--scrollbar-bg-color)}[command-root] [command-list]::-webkit-scrollbar-thumb{border:2px;border-color:var(--sg-color-black90);background:var(--scrollbar-thumb-color);border-radius:10px}[command-root] [command-list] .enhanced-search-instructions,[command-root] [command-list] .enhanced-search-no-results{padding-left:1.2em;padding-bottom:1.2em}[command-root] [command-list] .enhanced-search-instructions .enhanced-search-instructions__title,[command-root] [command-list] .enhanced-search-instructions .enhanced-search-instructions__intro,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-instructions__title,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-instructions__intro{font-size:.75em}[command-root] [command-list] .enhanced-search-instructions .enhanced-search-instructions__title svg,[command-root] [command-list] .enhanced-search-instructions .enhanced-search-instructions__intro svg,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-instructions__title svg,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-instructions__intro svg{color:var(--text-color);fill:currentColor;margin:0 .2em -.3em}[command-root] [command-list] .enhanced-search-instructions .enhanced-search-no-results__number,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-no-results__number{font-size:.8em;color:var(--text-color-light)}[command-root] [command-list] .enhanced-search-instructions .enhanced-search-no-results__intro,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-no-results__intro{font-size:.87em}[command-root] [command-list] .enhanced-search-instructions .enhanced-search-no-results__intro .enhanced-search-no-results__intro__search-term,[command-root] [command-list] .enhanced-search-no-results .enhanced-search-no-results__intro .enhanced-search-no-results__intro__search-term{color:var(--sg-color-blue)}[command-root] [command-list] .enhanced-search-instructions ul,[command-root] [command-list] .enhanced-search-no-results ul{font-size:.87em;padding:0 0 0 1em;line-height:2em}[command-root] [command-list] .enhanced-search-instructions ul li:before,[command-root] [command-list] .enhanced-search-no-results ul li:before{color:var(--text-color)}[command-root] [command-list] [command-group-heading]{font-size:.8em;padding-left:1.5em;color:var(--text-color-light);margin-bottom:.8em}[command-root] [command-list] [command-loading]{padding-inline:1.5em}[command-root] [command-list] [command-item]{font-size:.8em;padding:1em 1.5em;cursor:pointer;transition:background-color .1s;font-weight:500}[command-root] [command-list] [command-item]:hover,[command-root] [command-list] [command-item][aria-selected=true]{background-color:var(--bg-item-color-hover)}[command-root] [command-list] [command-item].search-item{padding:.8em 1.5em;display:flex;align-items:center;gap:1em}[command-root] [command-list] [command-item].search-item .search-item__image{height:3em;width:3em;border-radius:8em;overflow:hidden}[command-root] [command-list] [command-item].search-item .search-item__image img{width:100%;height:100%}[command-root] [command-list] [command-item].search-item .search-item__description{font-size:1.1em}[command-root] [command-list] [command-item].search-item .search-item__description p{margin:0}[command-root] [command-list] [command-item].search-item .search-item__description .search-item__description__title{margin-top:0;margin-bottom:.1em}[command-root] [command-list] [command-item].search-item .search-item__description .search-item__description__highlights{color:var(--text-color-light)}[command-root] [command-list] [command-item].search-item .search-item__description .search-item__description__highlights em{color:var(--sg-color-blue);font-style:normal}.command-enter-active,.command-leave-active{transition:opacity .2s ease-in-out}.command-enter-from,.command-leave-to{opacity:0}", sd = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, r] of t)
    n[s] = r;
  return n;
}, rd = /* @__PURE__ */ sd(td, [["styles", [nd]]]), Ui = /* @__PURE__ */ va(rd), id = {
  name: "VrmCommandK",
  props: {
    theme: {
      type: String,
      default: "light"
    },
    translations: {
      type: String,
      required: !0
    },
    translationsSearch: {
      type: String,
      default: ""
    },
    disabled: {
      type: String,
      default: "false"
    },
    showFleetMonitor: {
      type: String,
      default: "false"
    },
    searchResults: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select", "enhanced-search"],
  setup(e, { emit: t }) {
    return customElements.get("vrm-command-k") || customElements.define("vrm-command-k", Ui), () => en("vrm-command-k", {
      theme: e.theme,
      translations: e.translations,
      translationsSearch: e.translationsSearch,
      disabled: e.disabled,
      showFleetMonitor: e.showFleetMonitor,
      searchResults: e.searchResults,
      onSelect: (n) => t("select", n.detail),
      onInput: (n) => t("enhanced-search", n.detail)
    });
  }
};
function ld() {
  customElements.get("vrm-command-k") || customElements.define("vrm-command-k", Ui);
}
export {
  id as VrmCommandK,
  Ui as VrmCommandKElement,
  ld as register
};
//# sourceMappingURL=vrm-command-palette.es.js.map
